<template>
  <div style="width: 100%; height: 100%">
    <div
      style="
        width: 0.5376vw;
        height: 100%;
        display: flex;
        float: left;
        background: rgba(240, 240, 240, 1);
      "
    ></div>
    <div style="width: 6%; height: 100%; float: left"></div>
    <div style="width: 93%; height: 100%; float: left">
      <div style="width: 100%; height: 4.5%"></div>
      <div
        style="width: 100%; height: 5.5%; align-items: center; display: flex"
      >
        <div
          style="
            width: 20%;
            height: 100%;
            float: left;
            align-items: center;
            display: flex;
          "
          class="v41_161"
        >
          <span v-if="Lflag == true" class="v35_1047" style="width: 15%"
            >走航监测</span
          >
          <span v-if="Lflag == false" class="v35_1047" style="width: 15%"
            >EcoTracX</span
          >
        </div>
        <div
          style="
            width: 60%;
            height: 100%;
            float: left;
            align-items: center;
            display: flex;
          "
        ></div>
        <div
          style="
            width: 20%;
            height: 100%;
            float: right;
            align-items: center;
            justify-content: left;
            display: flex;
          "
          class="v41_161"
        >
          <span
            v-if="Lflag == true"
            class="v41_161"
            style="
              height: 0.8602vh;
              font-size: 0.8602vw;
              align-items: center;
              display: flex;
              justify-content: left;
            "
            >当前数据：{{ this.$store.state.eco_value ? (typeof this.$store.state.eco_value === "object" ? this.$store.state.eco_value.name || '' : this.$store.state.eco_value) : '' }}
          </span>
          <span
            v-if="Lflag == false"
            class="v41_161"
            style="
              height: 0.8602vh;
              font-size: 0.8602vw;
              align-items: center;
              display: flex;
              justify-content: left;
            "
            >Data：{{ this.$store.state.eco_value ? (typeof this.$store.state.eco_value === "object" ? this.$store.state.eco_value.name || '' : this.$store.state.eco_value) : '' }}
          </span>
        </div>
      </div>
      <div style="width: 97%; height: 2vh"></div>
      <div style="width: 97%; height: 10%">
        <div style="width: 75vw; height: 50%; position: relative; float: left">
          <el-drawer
            v-if="Lflag == true"
            title="设备详细信息"
            style="font-size: 1.0753vw"
            :visible.sync="drawer"
            :direction="direction"
            size="20%"
            :modal="false"
          >
            <div style="width: 100%; height: 5%; float: left; padding-left: 4%">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >时间：{{ this.time }}
              </span>
            </div>
            <div style="width: 52%; height: 5%; float: left; padding-left: 4%">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >经度：{{ this.longitude.toFixed(6) }}
              </span>
            </div>
            <div style="width: 48%; height: 5%; float: left; padding-left: 4%">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >纬度：{{ this.latitude.toFixed(6) }}
              </span>
            </div>
            <div style="width: 100%; height: 5%; float: left"></div>
            <div style="width: 50%; height: 5%; float: left; padding-left: 4%">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >CH4
              </span>
            </div>
            <div style="width: 50%; height: 5%; float: left">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >OSS：{{ this.oss_ch4 }}%
              </span>
            </div>

            <div style="width: 100%; height: 5%; float: left; padding-left: 4%">
              <el-tooltip placement="right" effect="light">
                <div slot="content" style="font-size: 0.9677vw">
                  报警信息为：<br />1：LD一级温度异常<br />2：MCT一级温度异常<br />3：实际电流超过实际限制电流<br />4：******预留报警位*****<br />5：LD一级测温断开<br />6：LD二级测温断开<br />7：MCT一级测温断开<br />8：MCT二级测温断开<br />9：******预留报警位******<br />10：******预留报警位******
                  <br />11：循环水温过高<br />12：测循环水温芯片断连<br />13：内部温度过高<br />14：内部湿度过高<br />15：测内部温湿度芯片断连<br />16：外接NTC断开<br />17：******预留报警位******<br />18：下镜片测温芯片通信失败<br />19：信号强度过低<br />20：浓度数据无效<br />21：LD二级温控异常
                  <br />22：MCT二级温控异常<br />23：未检测到激光器电流<br />24：参考池气体浓度过低<br />25：低功耗模式开启<br />26：******预留报警位******<br />27：设置电流有误<br />28：限制电流有误<br />29：供电电压异常<br />30：激光器&TEC参数没有设置完成<br />31：传感器检测有雨<br />32：水箱水位过低
                </div>
                <span
                  class="v41_161"
                  style="
                    float: left;
                    padding-top: 1.8817vh;
                    font-size: 0.9677vw;
                  "
                  >报警信息：{{ this.ch4_alarm }}
                </span>
              </el-tooltip>
            </div>
            <div style="width: 100%; height: 5%; float: left"></div>
            <div style="width: 50%; height: 5%; float: left; padding-left: 4%">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >N2O
              </span>
            </div>
            <div style="width: 50%; height: 5%; float: left">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >OSS：{{ this.oss_n2o }}%
              </span>
            </div>
            <div style="width: 100%; height: 5%; float: left; padding-left: 4%">
              <el-tooltip placement="right" effect="light">
                <div slot="content" style="font-size: 0.9677vw">
                  报警信息为：<br />1：LD一级温度异常<br />2：MCT一级温度异常<br />3：实际电流超过实际限制电流<br />4：******预留报警位*****<br />5：LD一级测温断开<br />6：LD二级测温断开<br />7：MCT一级测温断开<br />8：MCT二级测温断开<br />9：******预留报警位******<br />10：******预留报警位******
                  <br />11：循环水温过高<br />12：测循环水温芯片断连<br />13：内部温度过高<br />14：内部湿度过高<br />15：测内部温湿度芯片断连<br />16：外接NTC断开<br />17：******预留报警位******<br />18：下镜片测温芯片通信失败<br />19：信号强度过低<br />20：浓度数据无效<br />21：LD二级温控异常
                  <br />22：MCT二级温控异常<br />23：未检测到激光器电流<br />24：参考池气体浓度过低<br />25：低功耗模式开启<br />26：******预留报警位******<br />27：设置电流有误<br />28：限制电流有误<br />29：供电电压异常<br />30：激光器&TEC参数没有设置完成<br />31：传感器检测有雨<br />32：水箱水位过低
                </div>
                <span
                  class="v41_161"
                  style="
                    float: left;
                    padding-top: 1.8817vh;
                    font-size: 0.9677vw;
                  "
                  >报警信息：{{ this.n2o_alarm }}
                </span>
              </el-tooltip>
            </div>
            <!-- 
            <div style="width: 100%; height: 5%; float: left"></div>
            <div style="width: 50%; height: 5%; float: left">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 1.0753vw"
                >CO2
              </span>
            </div>
            <div style="width: 50%; height: 5%; float: left">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 1.0753vw"
                >OSS：{{ this.oss_co2 }}
              </span>
            </div>
            <div style="width: 100%; height: 5%; float: left">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 1.0753vw"
                >报警信息：
              </span>
            </div> -->
            <div style="width: 100%; height: 5%; float: left"></div>
            <div style="width: 50%; height: 5%; float: left; padding-left: 4%">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >NH3
              </span>
            </div>
            <div style="width: 50%; height: 5%; float: left">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >OSS：{{ this.oss_nh3 }}%
              </span>
            </div>
            <div style="width: 100%; height: 5%; float: left; padding-left: 4%">
              <el-tooltip placement="right" effect="light">
                <div slot="content" style="font-size: 0.9677vw">
                  报警信息为：<br />1：LD一级温度异常<br />2：MCT一级温度异常<br />3：实际电流超过实际限制电流<br />4：******预留报警位*****<br />5：LD一级测温断开<br />6：LD二级测温断开<br />7：MCT一级测温断开<br />8：MCT二级测温断开<br />9：******预留报警位******<br />10：******预留报警位******
                  <br />11：循环水温过高<br />12：测循环水温芯片断连<br />13：内部温度过高<br />14：内部湿度过高<br />15：测内部温湿度芯片断连<br />16：外接NTC断开<br />17：******预留报警位******<br />18：下镜片测温芯片通信失败<br />19：信号强度过低<br />20：浓度数据无效<br />21：LD二级温控异常
                  <br />22：MCT二级温控异常<br />23：未检测到激光器电流<br />24：参考池气体浓度过低<br />25：低功耗模式开启<br />26：******预留报警位******<br />27：设置电流有误<br />28：限制电流有误<br />29：供电电压异常<br />30：激光器&TEC参数没有设置完成<br />31：传感器检测有雨<br />32：水箱水位过低
                </div>
                <span
                  class="v41_161"
                  style="
                    float: left;
                    padding-top: 1.8817vh;
                    font-size: 0.9677vw;
                  "
                  >报警信息：{{ this.nh3_alarm }}
                </span>
              </el-tooltip>
            </div>
          </el-drawer>
          <el-drawer
            v-if="Lflag == false"
            title="Device details"
            style="font-size: 1.0753vw"
            :visible.sync="drawer"
            :direction="direction"
            size="20%"
            :modal="false"
          >
            <div style="width: 100%; height: 5%; float: left; padding-left: 4%">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >Time：{{ this.time }}
              </span>
            </div>
            <div style="width: 52%; height: 5%; float: left; padding-left: 4%">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >LON：{{ this.longitude.toFixed(6) }}
              </span>
            </div>
            <div style="width: 48%; height: 5%; float: left; padding-left: 4%">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >LAT：{{ this.latitude.toFixed(6) }}
              </span>
            </div>
            <div style="width: 100%; height: 5%; float: left"></div>
            <div style="width: 50%; height: 5%; float: left; padding-left: 4%">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >CH4
              </span>
            </div>
            <div style="width: 50%; height: 5%; float: left">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >OSS：{{ this.oss_ch4 }}%
              </span>
            </div>

            <div style="width: 100%; height: 5%; float: left; padding-left: 4%">
              <el-tooltip
                placement="right"
                effect="light"
                v-if="Lflag == false"
              >
                <div slot="content" style="font-size: 0.9677vw">
                  The alarm message is：<br />1：LD primary temperature is
                  abnormal<br />2：MCT primary temperature is abnormal<br />3：Actual
                  current exceeds the actual limit current<br />4：******Reserve
                  Alarm Position******<br />5：LD primary temperature
                  measurement disconnected<br />6：LD secondary temperature
                  measurement disconnected<br />7：MCT primary temperature
                  measurement disconnected<br />8：MCT secondary temperature
                  measurement disconnected<br />9：******Reserve Alarm
                  Position******<br />10：******Reserve Alarm Position******
                  <br />11：Circulating water temperature out of range<br />12：he
                  chip used to measure the temperature of circulating water is
                  disconnected<br />13：nternal temperature out of range<br />14：Internal
                  humidity out of range<br />15：The chip used to measure the
                  internal humidity is disconnected<br />16：External NTC
                  disconnected <br />17：******Reserve Alarm Position******<br />18：Communication
                  failure of temperature measuring chip on lower mirror<br />19：Weak
                  signal strength<br />20：Concentration data is invalid<br />21：LD
                  secondary temperature control anomaly <br />22：MCT secondary
                  temperature control anomaly<br />23：No laser current
                  detected<br />24：Low gas concentration in reference pool<br />25：Power
                  saving mode on<br />26：******Reserve Alarm Position******<br />27：Error
                  setting current<br />28：Error limiting current<br />29：Abnormal
                  supply voltage<br />30：The laser & TEC parameters not set
                  complete<br />31：The sensor detects rain<br />32：Water level
                  is too low
                </div>
                <span
                  class="v41_161"
                  style="
                    float: left;
                    padding-top: 1.8817vh;
                    font-size: 1.0753vw;
                  "
                  >The alarm message：{{ this.ch4_alarm }}
                </span>
              </el-tooltip>
            </div>

            <div style="width: 100%; height: 5%; float: left"></div>
            <div style="width: 50%; height: 5%; float: left; padding-left: 4%">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >N2O
              </span>
            </div>
            <div style="width: 50%; height: 5%; float: left">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 0.9677vw"
                >OSS：{{ this.oss_n2o }}
              </span>
            </div>
            <div style="width: 100%; height: 5%; float: left; padding-left: 4%">
              <el-tooltip
                placement="right"
                effect="light"
                v-if="Lflag == false"
              >
                <div slot="content" style="font-size: 0.9677vw">
                  The alarm message is：<br />1：LD primary temperature is
                  abnormal<br />2：MCT primary temperature is abnormal<br />3：Actual
                  current exceeds the actual limit current<br />4：******Reserve
                  Alarm Position******<br />5：LD primary temperature
                  measurement disconnected<br />6：LD secondary temperature
                  measurement disconnected<br />7：MCT primary temperature
                  measurement disconnected<br />8：MCT secondary temperature
                  measurement disconnected<br />9：******Reserve Alarm
                  Position******<br />10：******Reserve Alarm Position******
                  <br />11：Circulating water temperature out of range<br />12：he
                  chip used to measure the temperature of circulating water is
                  disconnected<br />13：nternal temperature out of range<br />14：Internal
                  humidity out of range<br />15：The chip used to measure the
                  internal humidity is disconnected<br />16：External NTC
                  disconnected <br />17：******Reserve Alarm Position******<br />18：Communication
                  failure of temperature measuring chip on lower mirror<br />19：Weak
                  signal strength<br />20：Concentration data is invalid<br />21：LD
                  secondary temperature control anomaly <br />22：MCT secondary
                  temperature control anomaly<br />23：No laser current
                  detected<br />24：Low gas concentration in reference pool<br />25：Power
                  saving mode on<br />26：******Reserve Alarm Position******<br />27：Error
                  setting current<br />28：Error limiting current<br />29：Abnormal
                  supply voltage<br />30：The laser & TEC parameters not set
                  complete<br />31：The sensor detects rain<br />32：Water level
                  is too low
                </div>
                <span
                  class="v41_161"
                  style="
                    float: left;
                    padding-top: 1.8817vh;
                    font-size: 1.0753vw;
                  "
                  >The alarm message：{{ this.n2o_alarm }}
                </span>
              </el-tooltip>
            </div>
            <!-- <div style="width: 100%; height: 5%; float: left"></div>
            <div style="width: 50%; height: 5%; float: left">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 1.0753vw"
                >CO2
              </span>
            </div>
            <div style="width: 50%; height: 5%; float: left">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 1.0753vw"
                >OSS：{{ this.oss_co2 }}
              </span>
            </div>
            <div style="width: 100%; height: 5%; float: left">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 1.0753vw"
                >报警信息：
              </span>
            </div> -->
            <div style="width: 100%; height: 5%; float: left"></div>
            <div style="width: 50%; height: 5%; float: left; padding-left: 4%">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 1.0753vw"
                >NH3
              </span>
            </div>
            <div style="width: 50%; height: 5%; float: left">
              <span
                class="v41_161"
                style="float: left; padding-top: 1.8817vh; font-size: 1.0753vw"
                >OSS：{{ this.oss_nh3 }}%
              </span>
            </div>
            <div style="width: 100%; height: 5%; float: left; padding-left: 4%">
              <el-tooltip
                placement="right"
                effect="light"
                v-if="Lflag == false"
              >
                <div slot="content" style="font-size: 0.9677vw">
                  The alarm message is：<br />1：LD primary temperature is
                  abnormal<br />2：MCT primary temperature is abnormal<br />3：Actual
                  current exceeds the actual limit current<br />4：******Reserve
                  Alarm Position******<br />5：LD primary temperature
                  measurement disconnected<br />6：LD secondary temperature
                  measurement disconnected<br />7：MCT primary temperature
                  measurement disconnected<br />8：MCT secondary temperature
                  measurement disconnected<br />9：******Reserve Alarm
                  Position******<br />10：******Reserve Alarm Position******
                  <br />11：Circulating water temperature out of range<br />12：he
                  chip used to measure the temperature of circulating water is
                  disconnected<br />13：nternal temperature out of range<br />14：Internal
                  humidity out of range<br />15：The chip used to measure the
                  internal humidity is disconnected<br />16：External NTC
                  disconnected <br />17：******Reserve Alarm Position******<br />18：Communication
                  failure of temperature measuring chip on lower mirror<br />19：Weak
                  signal strength<br />20：Concentration data is invalid<br />21：LD
                  secondary temperature control anomaly <br />22：MCT secondary
                  temperature control anomaly<br />23：No laser current
                  detected<br />24：Low gas concentration in reference pool<br />25：Power
                  saving mode on<br />26：******Reserve Alarm Position******<br />27：Error
                  setting current<br />28：Error limiting current<br />29：Abnormal
                  supply voltage<br />30：The laser & TEC parameters not set
                  complete<br />31：The sensor detects rain<br />32：Water level
                  is too low
                </div>
                <span
                  class="v41_161"
                  style="
                    float: left;
                    padding-top: 1.8817vh;
                    font-size: 1.0753vw;
                  "
                  >The alarm message：{{ this.nh3_alarm }}
                </span>
              </el-tooltip>
            </div>
          </el-drawer>
          <div
            style="
              width: 13%;
              height: 100%;
              float: left;
              display: flex;
              align-items: center;
            "
          >
            <span
              class="v41_161"
              style="float: left; font-size: 1.1828vw"
              v-if="Lflag == true"
              >温度：{{ this.temperature }}
              ℃
            </span>
            <span
              class="v41_161"
              style="float: left; font-size: 1.1828vw"
              v-if="Lflag == false"
              >Temp：{{ this.temperature }}℃
            </span>
          </div>
          <div
            style="
              width: 15%;
              height: 100%;
              float: left;
              display: flex;
              align-items: center;
            "
          >
            <span
              class="v41_161"
              style="font-size: 1.1828vw"
              v-if="Lflag == true"
              >气压：{{ this.pressure }}
              hpa
            </span>
            <span
              class="v41_161"
              style="font-size: 1.1828vw"
              v-if="Lflag == false"
              >Pressure：{{ this.pressure }}hpa
            </span>
          </div>
          <div
            style="
              width: 20%;
              height: 100%;
              float: left;
              display: flex;
              align-items: center;
            "
          >
            <span
              class="v41_161"
              style="font-size: 1.1828vw"
              v-if="Lflag == true"
              >风向风速: {{ this.wind }}° {{ this.windspeed }}m/s
            </span>
            <span
              class="v41_161"
              style="font-size: 1.1828vw"
              v-if="Lflag == false"
              >WD&WS: {{ this.wind }}° {{ this.windspeed }}m/s
            </span>
          </div>

          <div
            style="
              width: 13%;
              height: 100%;
              display: flex;
              float: right;
              justify-content: right;
              align-items: center;
            "
          >
            <el-button
              v-if="Lflag == true"
              @click="drawer = true"
              type="button"
              style="
                width: 90%;
                height: 80%;
                background-color: rgba(25, 44, 250, 1);
                padding-left: 1.801vw;
                padding-top: 1.0376vh;
                align-items: center;
                display: flex;
                border-radius: 0.2688vw;
                color: #fff;
                font-family: Microsoft YaHei UI;
                font-weight: Regular;
                font-size: 0.8602vw;
              "
            >
              查看设备信息
            </el-button>
            <el-button
              v-if="Lflag == false"
              @click="drawer = true"
              type="button"
              style="
                width: 90%;
                height: 80%;
                background-color: rgba(25, 44, 250, 1);
                padding-left: 1.801vw;
                padding-top: 1.0376vh;
                align-items: center;
                display: flex;
                border-radius: 0.2688vw;
                color: #fff;
                font-family: Microsoft YaHei UI;
                font-weight: Regular;
                font-size: 0.8602vw;
              "
            >
              View device
            </el-button>
          </div>
          <div
            style="
              width: 13%;
              height: 100%;
              display: flex;
              float: right;
              justify-content: right;
              align-items: center;
            "
          >
            <el-button
              v-if="Lflag == true"
              @click="
                centerDialogVisible = true;
                key += 1;
              "
              type="button"
              style="
                width: 90%;
                height: 80%;
                background-color: rgba(25, 44, 250, 1);
                padding-left: 0.95vw;
                padding-top: 1.0376vh;
                align-items: center;
                display: flex;
                border-radius: 0.2688vw;
                color: #fff;
                font-family: Microsoft YaHei UI;
                font-weight: Regular;
                font-size: 0.8602vw;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              结束并标记本次走航
            </el-button>
            <el-button
              v-if="Lflag == false"
              @click="
                centerDialogVisible = true;
                key += 1;
              "
              type="button"
              style="
                width: 90%;
                height: 80%;
                background-color: rgba(25, 44, 250, 1);
                padding-left: 0.95vw;
                padding-top: 1.0376vh;
                align-items: center;
                display: flex;
                border-radius: 0.2688vw;
                color: #fff;
                font-family: Microsoft YaHei UI;
                font-weight: Regular;
                font-size: 0.8602vw;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              End&Mark
            </el-button>
          </div>
          <div
            style="
              width: 13%;
              height: 100%;
              display: flex;
              float: right;
              justify-content: right;
              align-items: center;
            "
          >
            <el-button
              v-if="Lflag == true"
              @click="his_click()"
              type="button"
              style="
                width: 90%;
                height: 80%;
                background-color: rgba(25, 44, 250, 1);
                padding-left: 0.8501vw;
                padding-top: 1.0376vh;
                align-items: center;
                display: flex;
                border-radius: 0.2688vw;
                color: #fff;
                font-family: Microsoft YaHei UI;
                font-weight: Regular;
                font-size: 0.8602vw;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              数据来源
            </el-button>
            <el-button
              v-if="Lflag == false"
              @click="his_click()"
              type="button"
              style="
                width: 90%;
                height: 80%;
                background-color: rgba(25, 44, 250, 1);
                padding-left: 0.8501vw;
                padding-top: 1.0376vh;
                align-items: center;
                display: flex;
                border-radius: 0.2688vw;
                color: #fff;
                font-family: Microsoft YaHei UI;
                font-weight: Regular;
                font-size: 0.8602vw;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              Data source
            </el-button>
          </div>
          <div
            style="
              width: 13%;
              height: 100%;
              display: flex;
              float: right;
              justify-content: right;
              align-items: center;
            "
          >
            <el-button
              v-if="Lflag == true"
              @click="setfilename()"
              type="button"
              style="
                width: 90%;
                height: 80%;
                background-color: rgba(25, 44, 250, 1);
                padding-left: 0.8501vw;
                padding-top: 1.0376vh;
                align-items: center;
                display: flex;
                border-radius: 0.2688vw;
                color: #fff;
                font-family: Microsoft YaHei UI;
                font-weight: Regular;
                font-size: 0.8602vw;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              下载
            </el-button>
            <el-button
              v-if="Lflag == false"
              @click="exportflag = true"
              type="button"
              style="
                width: 90%;
                height: 80%;
                background-color: rgba(25, 44, 250, 1);
                padding-left: 0.8501vw;
                padding-top: 1.0376vh;
                align-items: center;
                display: flex;
                border-radius: 0.2688vw;
                color: #fff;
                font-family: Microsoft YaHei UI;
                font-weight: Regular;
                font-size: 0.8602vw;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              Download
            </el-button>
          </div>
        </div>
        <!-- 4 地图容器 2x2 网格 -->
        <div style="width: 97%; height: 2vh"></div>
        <div id="map-area-wrapper" style="width: 100%; position: relative;">
          <!-- 全屏退出按钮（相对地图区域左上角） -->
          <el-button
            id="btn"
            v-if="zoomflag == false"
            class="btn"
            type="text"
            icon="el-icon-close"
            @click="shrink"
            style="top: 4vh; left: 0.5%; z-index: 1000; font-size: 1.5vw;"
          ></el-button>
          <div class="map-row" style="width: 100%; height: 47%">
          <div id="con1" style="width: 47%; height: 30vh; position: relative; float: left">
            <div style="width: 100%; height: 100%; min-height: 200px" id="container1"></div>
            <el-button v-if="zoomflag == true" id="btn1" class="btn" type="text" icon="el-icon-full-screen" @click="magnify('1')" style="top: 0.7%"></el-button>
            <div class="chart-container" v-show="showChart1" style="width: 42%; height: 36%">
              <div id="lineChart1" style="width: 14.3011vw; height: 11.7vh"></div>
            </div>
            <button v-if="color_flag1 == true" class="toggle-button" :class="{ expanded: isExpanded1 }" @click="set_chat(1)" :style="buttonStyle1">
              <span class="arrow">{{ arrowSymbol1 }}</span>
            </button>
            <div v-if="color_flag1 == true" id="VerticalColorScale1" style="position: absolute; width: 3.3vw; height: 15vh; background-color: rgb(239, 235, 235); opacity: 0.7; font-size: 0.5376vw; z-index: 100; left: 90%; top: 45%;">
              <div class="mc-ui-absolute-pane" style="position: absolute; left: 10.6735%; top: 16.0804%; width: 20%; height: 80%;">
                <div style="width: 100%; height: 16%; background-color: rgb(146, 2, 151);"></div>
                <div style="width: 100%; height: 16%; background-color: rgb(163, 4, 15);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(230, 4, 4);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(234, 156, 6);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(234, 199, 6);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(6, 234, 119);"></div>
              </div>
              <label style="position: absolute; top: 3.02513%; width: 100%; font-size: 0.4301vw; text-align: center;">(ppb)</label>
              <label style="position: absolute; left: 35.1224%; top: 79.8995%; width: 30%;">{{ standard1[0] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 66.5829%; width: 30%;">{{ standard1[1] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 53.6432%; width: 30%;">{{ standard1[2] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 40.4523%; width: 30%;">{{ standard1[3] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 27.6382%; width: 30%;">{{ standard1[4] }}</label>
            </div>
          </div>
          <div style="width: 3%; height: 30vh; position: relative; float: left"></div>
          <div id="con2" style="width: 47%; height: 30vh; position: relative; float: left">
            <div style="width: 100%; height: 100%; min-height: 200px" id="container2"></div>
            <el-button v-if="zoomflag == true" id="btn1" class="btn" type="text" icon="el-icon-full-screen" @click="magnify('2')" style="top: 0.7%"></el-button>
            <div class="chart-container" v-show="showChart2" style="width: 42%; height: 36%">
              <div id="lineChart2" style="width: 14.3011vw; height: 11.7vh"></div>
            </div>
            <button v-if="color_flag2 == true" class="toggle-button" :class="{ expanded: isExpanded2 }" @click="set_chat(2)" :style="buttonStyle2">
              <span class="arrow">{{ arrowSymbol2 }}</span>
            </button>
            <div v-if="color_flag2 == true" id="VerticalColorScale2" style="position: absolute; width: 3.3vw; height: 15vh; background-color: rgb(239, 235, 235); opacity: 0.7; font-size: 0.5376vw; z-index: 100; left: 90%; top: 45%;">
              <div class="mc-ui-absolute-pane" style="position: absolute; left: 10.6735%; top: 16.0804%; width: 20%; height: 80%;">
                <div style="width: 100%; height: 16%; background-color: rgb(146, 2, 151);"></div>
                <div style="width: 100%; height: 16%; background-color: rgb(163, 4, 15);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(230, 4, 4);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(234, 156, 6);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(234, 199, 6);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(6, 234, 119);"></div>
              </div>
              <label style="position: absolute; top: 3.02513%; width: 100%; font-size: 0.4301vw; text-align: center;">(ppb)</label>
              <label style="position: absolute; left: 35.1224%; top: 79.8995%; width: 30%;">{{ standard2[0] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 66.5829%; width: 30%;">{{ standard2[1] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 53.6432%; width: 30%;">{{ standard2[2] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 40.4523%; width: 30%;">{{ standard2[3] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 27.6382%; width: 30%;">{{ standard2[4] }}</label>
            </div>
          </div>
        </div>
        <div style="width: 100%; height: 2vh"></div>
        <div style="width: 100%; height: 8%;">
          <div style="width: 47%; height: 100%; position: relative; float: left; display: flex; align-items: center; justify-content: center;">
            <span v-if="zoomflag == true" class="v41_161" style="font-size: 1.1828vw; margin-top: 1vh;">{{ lable1 }} : {{ concentration1 }}</span>
          </div>
          <div style="width: 47%; height: 100%; position: relative; float: right; display: flex; align-items: center; justify-content: center;">
            <span v-if="zoomflag == true" class="v41_161" style="font-size: 1.1828vw; margin-top: 1vh;">{{ lable2 }} : {{ concentration2 }}</span>
          </div>
        </div>
        <div style="width: 100%; height: 47%">
          <div id="con3" style="width: 47%; height: 30vh; position: relative; float: left">
            <div style="width: 100%; height: 100%; min-height: 200px" id="container3"></div>
            <el-button v-if="zoomflag == true" id="btn1" class="btn" type="text" icon="el-icon-full-screen" @click="magnify('3')" style="top: 0.7%"></el-button>
            <div class="chart-container" v-show="showChart3" style="width: 42%; height: 36%">
              <div id="lineChart3" style="width: 14.3011vw; height: 11.7vh"></div>
            </div>
            <button v-if="color_flag3 == true" class="toggle-button" :class="{ expanded: isExpanded3 }" @click="set_chat(3)" :style="buttonStyle3">
              <span class="arrow">{{ arrowSymbol3 }}</span>
            </button>
            <div v-if="color_flag3 == true" id="VerticalColorScale3" style="position: absolute; width: 3.3vw; height: 15vh; background-color: rgb(239, 235, 235); opacity: 0.7; font-size: 0.5376vw; z-index: 100; left: 90%; top: 45%;">
              <div class="mc-ui-absolute-pane" style="position: absolute; left: 10.6735%; top: 16.0804%; width: 20%; height: 80%;">
                <div style="width: 100%; height: 16%; background-color: rgb(146, 2, 151);"></div>
                <div style="width: 100%; height: 16%; background-color: rgb(163, 4, 15);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(230, 4, 4);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(234, 156, 6);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(234, 199, 6);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(6, 234, 119);"></div>
              </div>
              <label style="position: absolute; top: 3.02513%; width: 100%; font-size: 0.4301vw; text-align: center;">(ppm)</label>
              <label style="position: absolute; left: 35.1224%; top: 79.8995%; width: 30%;">{{ standard3[0] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 66.5829%; width: 30%;">{{ standard3[1] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 53.6432%; width: 30%;">{{ standard3[2] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 40.4523%; width: 30%;">{{ standard3[3] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 27.6382%; width: 30%;">{{ standard3[4] }}</label>
            </div>
          </div>
          <div style="width: 3%; height: 30vh; position: relative; float: left"></div>
          <div id="con4" style="width: 47%; height: 30vh; position: relative; float: left">
            <div style="width: 100%; height: 100%; min-height: 200px" id="container4"></div>
            <el-button v-if="zoomflag == true" id="btn1" class="btn" type="text" icon="el-icon-full-screen" @click="magnify('4')" style="top: 0.7%"></el-button>
            <div class="chart-container" v-show="showChart4" style="width: 42%; height: 36%">
              <div id="lineChart4" style="width: 14.3011vw; height: 11.7vh"></div>
            </div>
            <button v-if="color_flag4 == true" class="toggle-button" :class="{ expanded: isExpanded4 }" @click="set_chat(4)" :style="buttonStyle4">
              <span class="arrow">{{ arrowSymbol4 }}</span>
            </button>
            <div v-if="color_flag4 == true" id="VerticalColorScale4" style="position: absolute; width: 3.3vw; height: 15vh; background-color: rgb(239, 235, 235); opacity: 0.7; font-size: 0.5376vw; z-index: 1000; left: 90%; top: 45%;">
              <div class="mc-ui-absolute-pane" style="position: absolute; left: 10.6735%; top: 16.0804%; width: 20%; height: 80%;">
                <div style="width: 100%; height: 16%; background-color: rgb(146, 2, 151);"></div>
                <div style="width: 100%; height: 16%; background-color: rgb(163, 4, 15);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(230, 4, 4);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(234, 156, 6);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(234, 199, 6);"></div>
                <div style="width: 100%; height: 17%; background-color: rgb(6, 234, 119);"></div>
              </div>
              <label style="position: absolute; top: 3.02513%; width: 100%; font-size: 0.4301vw; text-align: center;">(ppb)</label>
              <label style="position: absolute; left: 35.1224%; top: 79.8995%; width: 30%;">{{ standard4[0] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 66.5829%; width: 30%;">{{ standard4[1] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 53.6432%; width: 30%;">{{ standard4[2] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 40.4523%; width: 30%;">{{ standard4[3] }}</label>
              <label style="position: absolute; left: 35.1224%; top: 27.6382%; width: 30%;">{{ standard4[4] }}</label>
            </div>
          </div>
        </div>
      </div> <!-- /map-area-wrapper -->
        <div style="width: 100%; height: 1vh"></div>
        <div style="width: 100%; height: 8%;">
          <div style="width: 47%; height: 100%; position: relative; float: left; display: flex; align-items: center; justify-content: center;">
            <span v-if="zoomflag == true" class="v41_161" style="font-size: 1.1828vw; margin-top: 1vh;">{{ lable3 }} : {{ concentration3 }}</span>
          </div>
          <div style="width: 47%; height: 100%; position: relative; float: right; display: flex; align-items: center; justify-content: center;">
            <span v-if="zoomflag == true" class="v41_161" style="font-size: 1.1828vw; margin-top: 1vh;">{{ lable4 }} : {{ concentration4 }}</span>
          </div>
        </div>
        <el-dialog
          v-if="Lflag == true"
          :visible.sync="exportflag"
          @close="exportflag = false"
        >
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
            style="padding-top: 0.0538vw; padding-bottom: 0.0538vw"
          >
            <el-tab-pane label="数据下载" name="first"
              ><div
                style="
                  width: 60%;
                  float: left;
                  display: flex;
                  justify-content: left;
                  align-items: center;
                  font-size: 1.0753vw;
                "
              >
                文件命名：
                <el-input style="width: 60%" v-model="filename"></el-input></div
            ></el-tab-pane>
            <el-tab-pane label="走航报告下载" name="second">
              <div
                style="
                  width: 60%;
                  float: left;
                  display: flex;
                  justify-content: left;
                  align-items: center;
                  font-size: 1.0753vw;
                "
              >
                文件命名：
                <el-input
                  id="pdfname"
                  style="width: 60%"
                  v-model="pdfname"
                ></el-input>
              </div>
            </el-tab-pane>
            <el-tab-pane
              label="走航报告上传"
              name="third"
              v-if="upload_flag == true"
            >
              <div
                style="
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  font-size: 1.0753vw;
                "
              >
                <el-upload
                  class="upload-demo"
                  drag
                  action="#"
                  :data="formData"
                  :headers="headers"
                  :before-upload="beforeUpload"
                  :http-request="customRequest"
                  accept=".pdf"
                  multiple
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    将文件拖到此处，或<em>点击上传</em>
                  </div>
                  <div class="el-upload__tip" slot="tip">只能上传pdf文件</div>
                </el-upload>
              </div>
            </el-tab-pane>
          </el-tabs>

          <div style="width: 100%; height: 5vh"></div>
          <div slot="footer" class="dialog-footer">
            <el-button
              type="primary"
              @click="download()"
              style="
                padding-top: 1vh;
                padding-left: 0.538vw;
                padding-bottom: 1vh;
                padding-right: 0.538vw;
              "
              >确 定</el-button
            >
            <el-button
              @click="exportflag = false"
              style="
                padding-top: 1vh;
                padding-left: 0.538vw;
                padding-bottom: 1vh;
                padding-right: 0.538vw;
              "
              >取 消</el-button
            >
          </div>
        </el-dialog>
        <el-dialog
          v-if="Lflag == false"
          :visible.sync="exportflag"
          @close="exportflag = false"
        >
          <div
            style="
              width: 60%;
              float: left;
              display: flex;
              justify-content: left;
              align-items: center;
              font-size: 1.0753vw;
            "
          >
            File naming：
            <el-input style="width: 60%" v-model="filename"></el-input>
          </div>
          <div style="width: 100%; height: 5vh"></div>
          <div slot="footer" class="dialog-footer">
            <el-button
              type="primary"
              @click="download()"
              style="
                padding-top: 1vh;
                padding-left: 0.538vw;
                padding-bottom: 1vh;
                padding-right: 0.538vw;
              "
              >Ok</el-button
            >
            <el-button
              @click="exportflag = false"
              style="
                padding-top: 1vh;
                padding-left: 0.538vw;
                padding-bottom: 1vh;
                padding-right: 0.538vw;
              "
              >Cancel</el-button
            >
          </div>
        </el-dialog>
        <el-dialog
          v-if="Lflag == true"
          title="结束本次走航并命名"
          :visible.sync="centerDialogVisible"
          @close="centerDialogVisible = false"
        >
          <div
            style="
              width: 45%;
              float: left;
              display: flex;
              justify-content: left;
              align-items: center;
              font-size: 1.0753vw;
            "
          >
            走航名称： <el-input style="width: 60%" v-model="name"></el-input>
          </div>
          <div class="block" style="width: 50%; float: left">
            <el-date-picker
              v-model="DataTime"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期 "
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00']"
              style="width: 100%"
              popper-class="picker-popper"
              :key="key"
            >
            </el-date-picker>
          </div>
          <div style="width: 100%; height: 5vh"></div>
          <div slot="footer" class="dialog-footer">
            <el-button
              type="primary"
              @click="resetmap"
              style="
                padding-top: 1vh;
                padding-left: 0.538vw;
                padding-bottom: 1vh;
                padding-right: 0.538vw;
              "
              >确 定</el-button
            >
            <el-button
              @click="centerDialogVisible = false"
              style="
                padding-top: 1vh;
                padding-left: 0.538vw;
                padding-bottom: 1vh;
                padding-right: 0.538vw;
              "
              >取 消</el-button
            >
          </div>
        </el-dialog>
        <el-dialog
          v-if="Lflag == false"
          title="End the trip and name it"
          :visible.sync="centerDialogVisible"
          @close="centerDialogVisible = false"
        >
          <div
            style="
              width: 45%;
              float: left;
              display: flex;
              justify-content: left;
              align-items: center;
              font-size: 1.0753vw;
            "
          >
            Name： <el-input style="width: 60%" v-model="name"></el-input>
          </div>
          <div class="block" style="width: 50%; float: left">
            <el-date-picker
              v-model="DataTime"
              type="datetimerange"
              start-placeholder="Start date"
              end-placeholder="End date "
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00']"
              style="width: 100%"
              popper-class="picker-popper"
              :key="key"
            >
            </el-date-picker>
          </div>
          <div style="width: 100%; height: 5vh"></div>
          <div slot="footer" class="dialog-footer">
            <el-button
              type="primary"
              @click="resetmap"
              style="
                padding-top: 1vh;
                padding-left: 0.538vw;
                padding-bottom: 1vh;
                padding-right: 0.538vw;
              "
            >
              OK</el-button
            >
            <el-button
              @click="centerDialogVisible = false"
              style="
                padding-top: 1vh;
                padding-left: 0.538vw;
                padding-bottom: 1vh;
                padding-right: 0.538vw;
              "
              >Cancel</el-button
            >
          </div>
        </el-dialog>
        <!-- ─── 选择数据来源（中文） ──────────── -->
        <el-dialog
          title="选择数据来源"
          v-if="Lflag == true"
          :visible.sync="DataHis_flag"
          @close="DataHis_flag = false"
        >
          <div style="display: flex; align-items: center; margin-bottom: 10px;">
            <span style="font-size: 1.0753vw; margin-right: 10px;">选择走航名称：</span>
            <el-select v-model="value" placeholder="选择" @change="menuChange" style="width: 200px;">
              <el-option v-for="item in options" :key="item.name" :label="item.name" :value="item.name"></el-option>
            </el-select>
            <div class="block" style="margin-left: 20px;">
              <el-date-picker
                v-model="HisTime"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00']"
                style="width: 100%"
                popper-class="picker-popper"
                :key="key"
              ></el-date-picker>
            </div>
            <el-button type="text" @click="delete_his(false)" style="margin-left: 20px;">
              <span class="v41_161" style="font-size: 0.9677vw">删除当前记录</span>
            </el-button>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="hisData" style="padding: 1vh 0.538vw;">确 定</el-button>
            <el-button @click="DataHis_flag = false" style="padding: 1vh 0.538vw;">取 消</el-button>
          </div>
        </el-dialog>

        <!-- ─── Select data source (English) ──── -->
        <el-dialog
          title="Select a data source"
          v-if="Lflag == false"
          :visible.sync="DataHis_flag"
          @close="DataHis_flag = false"
        >
          <div style="display: flex; align-items: center; margin-bottom: 10px;">
            <span style="font-size: 1.0753vw; margin-right: 10px;">Trip name：</span>
            <el-select v-model="value" placeholder="Please select" @change="menuChange" style="width: 200px;">
              <el-option v-for="item in options" :key="item.name" :label="item.name" :value="item.name"></el-option>
            </el-select>
            <div class="block" style="margin-left: 20px;">
              <el-date-picker
                v-model="HisTime"
                type="datetimerange"
                start-placeholder="Start date"
                end-placeholder="End date"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00']"
                style="width: 100%"
                popper-class="picker-popper"
                :key="key"
              ></el-date-picker>
            </div>
            <el-button type="text" @click="delete_his(false)" style="margin-left: 20px;">
              <span class="v41_161" style="font-size: 0.9677vw">Deletes the record</span>
            </el-button>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="hisData" style="padding: 1vh 0.538vw;">OK</el-button>
            <el-button @click="DataHis_flag = false" style="padding: 1vh 0.538vw;">Cancel</el-button>
          </div>
        </el-dialog>

        <!-- ─── 删除记录确认（中英双语） ──────── -->
        <el-dialog
          v-if="Lflag == true"
          title="删除走航记录"
          :visible.sync="delete_flag"
          @close="delete_flag = false"
        >
          <div style="width:100%; color:red; font-size:1.0753vw; display:flex; justify-content:center; align-items:center;">
            确定要删除&nbsp;&nbsp;"{{ this.value }}"&nbsp;&nbsp;此条记录吗？
          </div>
          <div style="width:100%; height:5vh"></div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="delete_his(true)" style="padding:1vh 0.538vw;">确 定</el-button>
            <el-button @click="delete_flag = false" style="padding:1vh 0.538vw;">取 消</el-button>
          </div>
        </el-dialog>
        <el-dialog
          v-if="Lflag == false"
          title="Delete the cruise record"
          :visible.sync="delete_flag"
          @close="delete_flag = false"
        >
          <div style="width:100%; color:red; font-size:1.0753vw; display:flex; justify-content:center; align-items:center;">
            Are you sure to delete&nbsp;&nbsp;"{{ this.value }}"?
          </div>
          <div style="width:100%; height:5vh"></div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="delete_his(true)" style="padding:1vh 0.538vw;">Confirm</el-button>
            <el-button @click="delete_flag = false" style="padding:1vh 0.538vw;">Cancel</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { checkToken } from "@/api/user";
import { askecomap } from "@/api/data";
import { askECOdata } from "@/api/data";
import { askhistory } from "@/api/data";
import { ask_plume } from "@/api/data";
import { delete_timelag } from "@/api/data";
import { upload_ECO_report } from "@/api/data";
import { askhistory_by_end_time } from "@/api/data";
import { select_data_by_time } from "@/api/data";
import { get_time_lag } from "@/api/data";
import { setstart } from "@/api/data";
import { setend } from "@/api/data";
import Map from "ol/Map";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import XYZ from "ol/source/XYZ";
import { fromLonLat } from "ol/proj";
import Feature from "ol/Feature";
import LineString from "ol/geom/LineString";
import Point from "ol/geom/Point";
import { Style, Stroke, Fill, Circle } from "ol/style";
import * as echarts from "echarts";
import axios from "axios";
export default {
  data() {
    return {
      username: "", //用于接收从state里传过来的用户名
      project: "", //用于接收从state里传过来的项目名
      Lflag: true,
      zoomflag: true, //用于区分地图是否放大
      zoom_num: "",
      concentration1: "", //CH4浓度
      concentration2: "", //N2O浓度
      concentration3: "", //浓度3
      concentration4: "", //浓度4
      concentration5: "", //浓度5
      concentrationList1: [], //CH4浓度数组
      concentrationList2: [], //N2O浓度数组
      concentrationList3: [], //浓度3
      concentrationList4: [], //浓度4
      concentrationList5: [], //浓度5
      drive_direction: "", //行驶方向
      car_speed: "", //车速
      time: "", //时间
      windspeed: "", //风速
      wind: "", //风向
      longitude: 0, //经度
      latitude: 0, //纬度
      longitudeList: [], //经度数组
      latitudeList: [], //纬度数组
      temperature: "", //温度
      pressure: "", //气压
      indexList: [], //表头数组
      site: "",
      LLlist: [], //实时数据经纬度数组
      HLLlist: [], //历史数据经纬度数组
      temp: [], //临时存放经纬度
      lable1: "CH4_ppb",
      lable2: "N2O_ppb",
      lable3: "CO2_ppm",
      lable4: "NH3_ppb",
      refreshflag: false, //是否索要实时数据的标志位
      con_cnt: 0, //实时数据错误计数，连续30次数据为Wrong data，判断为连接异常，停止实时数据索要
      standard_color: [
        [0.0235, 0.9176, 0.4667, 0.5], //绿
        [0.9176, 0.78, 0.0235, 0.5], //黄
        [0.9176, 0.6117, 0.0235, 0.5], //橙
        [0.9019, 0.1568, 0.1568, 0.5], //红
        [0.639, 0.01568, 0.0588, 0.5], //赤
        [0.5725, 0.00784, 0.592, 0.5], //紫
      ], //颜色挡位
      // standard1: [2000, 2050, 2100, 2200, 2500], //浓度1浓度挡位
      standard1: [2100, 2200, 2500, 3000, 4000], //浓度1浓度挡位
      standard2: [350, 370, 400, 450, 500], //浓度2浓度挡位
      standard3: [400, 500, 700, 1000, 1500], //浓度3浓度挡位
      standard4: [20, 50, 100, 200, 400], //浓度4浓度挡位
      color_flag1: true, //用于隐藏颜色图例的标志位
      color_flag2: true,
      color_flag3: true,
      color_flag4: true,
      drawer: false, //设备信息标志位
      direction: "ltr", //设备信息弹出方向
      oss_ch4: "",
      ch4_alarm: "",
      oss_n2o: "",
      n2o_alarm: "",
      oss_co2: "",
      oss_nh3: "",
      nh3_alarm: "",
      centerDialogVisible: false, //重新绘图界面标志位
      start_time: "", //重新绘图开始时间
      compute_flag: false,
      sun: "",
      Time: "",
      cloud: "0.1",
      grid_lon1: "121",
      grid_lat1: "34",
      grid_lon2: "122",
      grid_lat2: "34.5",
      xs: "121.12345",
      ys: "34.12345",
      hs: "2",
      z: "3",
      z0: "0.1",
      option1: [
        {
          value: "强",
          label: "强",
        },
        {
          value: "中",
          label: "中",
        },
        {
          value: "弱",
          label: "弱",
        },
      ],
      option2: [
        {
          value: "白天",
          label: "白天",
        },
        {
          value: "黑夜",
          label: "黑夜",
        },
      ],
      name: "", //走航名称
      DataTime: [], //走航数据时间范围
      key: 0, //时间选择器刷新k
      HisTime: [], //历史数据时间范围
      start_flag: false, //用于记录起始时间
      DataHis_flag: false, //查看历史数据弹框
      options: [], //历史数据列表
      value: null, //查询历史数据时选择的name

      optionMin: "", //加载提示
      gears_reset: false, //档位调整
      delete_flag: false, //删除确认界面
      init_flag: false,
      exportTable: [], //用于数据导出的数组
      exportflag: false, //数据导出弹窗
      filename: "", //文件名称

      alphaValue: 50, //透明度%
      showChart1: true,
      isExpanded1: false,
      showChart2: true,
      isExpanded2: false,
      showChart3: true,
      isExpanded3: false,
      showChart4: true,
      isExpanded4: false,
      myChart1: "", //图表
      listdata1: [], //图表数据数组
      myChart2: "",
      listdata2: [],
      myChart3: "",
      listdata3: [],
      myChart4: "",
      listdata4: [],
      activeName: "first",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      formData: {
        site: this.$store.state.site,
        name: this.$store.state.eco_value,
      },
      downloadmode: 1,
      pdfname: "",
      pdflist: [],
      upload_flag: false,
      tdtKey: '336323d30619cd003065c070cf628bc3',
      olMap1: null,
      olMap2: null,
      olMap3: null,
      olMap4: null,
      concSource1: null,
      concSource2: null,
      concSource3: null,
      concSource4: null,
      heatSource1: null,
      heatSource2: null,
      heatSource3: null,
      heatSource4: null,
      showHeatmap: true,   // 热力图显示开关
      showColorLine: true, // 彩色线显示开关
    };
  },
  created() {
    //created里的指令在该组件创建的时候执行，created比mounted更早执行
    //const selectedProjectId = this.$store.state.projectId; //将项目选择界面所选择的项目id传给selectedProjectId，用于发送网络请求获取对应项目的信息
    //console.log(selectedProjectId); //打印，用于测试
    this.Lflag = this.$store.state.Language; //store里的传到该组件
    checkToken(this.$qs.stringify({ token: this.$store.state.token })).then(
      (res) => {
        //发送请求：让后端检查token，后端返回的状态在request的response interceptor里拦截并作出相应的响应
        //console.log(res);
      }
    );
    this.$store.commit("restoreproject"); //将保存在本地的项目名传给state
    this.project = this.$store.state.project; //将state里的project赋值给组件里的project
    this.table = "`" + this.$store.state.site + "_map" + "`"; //将分割出的第二部分赋值给table并且加上后缀
    this.database = this.project[0];
    console.log(this.database);
    console.log(this.table);
    askecomap(
      this.$qs.stringify({ database: this.database, table: this.table })
    ).then((res) => {
      console.log(res);
      this.indexList = res.data;
    });
    this.site = this.$store.state.site + "_dat";
    get_time_lag(this.$qs.stringify({ site: this.$store.state.site })).then(
      (res) => {
        this.options = res.data;
        this.options.unshift({ name: "实时数据", start: "", end: "" });
        console.log(this.options);
        var text = "数据加载中";
        if (this.Lflag == false) {
          text = "The data is loading";
        }
        this.optionMin = this.$message({
          showClose: true,
          message: text,
          duration: 30 * 1000,
          center: true,
          type: "success",
          customClass: "customclass",
        });
        console.log(this.$store.state.eco_value);
        if (
          this.$store.state.eco_value == null ||
          this.$store.state.eco_value == "实时数据"
        ) {
          askhistory_by_end_time(
            this.$qs.stringify({ site: this.$store.state.site })
          ).then((res) => {
            console.log(res.data);
            this.exportTable = res.data;
            if (
              res.data.length > 1 ||
              this.$store.state.eco_value == "实时数据"
            ) {
              if (this.$store.state.eco_value == "实时数据") {
                this.value = this.$store.state.eco_value;
              }
              this.$store.commit("seteco_value", "实时数据");
              this.value = this.options[this.options.length - 1].name;
              this.HisTime[0] = this.options[this.options.length - 1].start;
              this.HisTime[1] = this.options[this.options.length - 1].end;
              this.concentrationList1 = [];
              this.concentrationList2 = [];
              this.concentrationList3 = [];
              this.concentrationList4 = [];
              this.concentrationList5 = [];
              this.longitudeList = [];
              this.latitudeList = [];
              this.HLLlist = [];
              for (let i = 5; i <= res.data.length - 1; i++) {
                this.Datahandle(res.data[i]);
                if (i == 5) {
                  this.DataTime[0] = this.time;
                  this.start_flag = true;
                  console.log(this.time);
                } else if (i == res.data.length - 1) {
                  this.DataTime[1] = this.time;
                }
                if (this.longitude != 0 && this.latitude != 0) {
                  this.HLLlist.push([this.longitude, this.latitude]);
                }
              }
              this.initMaps(0, 1, 1, 1, 1);
              if (this.optionMin) {
                this.optionMin.close();
              }
              this.refreshflag = true;
            } else {
              this.value = this.options[this.options.length - 1].name;
              this.HisTime[0] = this.options[this.options.length - 1].start;
              this.HisTime[1] = this.options[this.options.length - 1].end;
              this.$store.commit("seteco_value", this.value);
              this.$store.commit("seteco_time", this.HisTime);
              console.log(
                this.options[this.options.length - 1].start,
                this.HisTime[1],
                this.$store.state.site
              );
              select_data_by_time(
                this.$qs.stringify({
                  start: this.HisTime[0],
                  end: this.HisTime[1],
                  table: this.$store.state.site,
                })
              ).then((res) => {
                console.log(res.data);
                this.exportTable = res.data;
                this.value = "实时数据";
                this.HisTime = [];
                this.concentrationList1 = [];
                this.concentrationList2 = [];
                this.concentrationList3 = [];
                this.concentrationList4 = [];
                this.concentrationList5 = [];
                this.longitudeList = [];
                this.latitudeList = [];
                this.HLLlist = [];
                this.listdata1 = [];
                this.listdata2 = [];
                this.listdata3 = [];
                this.listdata4 = [];
                this.concentration1 = 0;
                this.concentration2 = 0;
                this.concentration3 = 0;
                this.concentration4 = 0;
                this.concentration5 = 0;
                for (let i = 5; i <= res.data.length - 1; i++) {
                  this.Datahandle(res.data[i]);
                  if (this.longitude != 0 && this.latitude != 0) {
                    this.HLLlist.push([this.longitude, this.latitude]);
                  }
                }
                //console.log(this.HLLlist);
                this.initMaps(0, 1, 1, 1, 1);
                if (this.optionMin) {
                  this.optionMin.close();
                }
                this.refreshflag = false;
              });
            }
          });
        } else {
          this.value = this.$store.state.eco_value;
          this.HisTime = this.$store.state.eco_time;
          // for (let i = 0; i < this.options.length - 1; i++) {
          //   if (this.options[i].name == this.value) {
          //     this.HisTime[0] = this.options[i].start;
          //     this.HisTime[1] = this.options[i].end;
          //   }
          // }
          console.log(this.HisTime[0], this.HisTime[1], this.$store.state.site);
          select_data_by_time(
            this.$qs.stringify({
              start: this.HisTime[0],
              end: this.HisTime[1],
              table: this.$store.state.site,
            })
          ).then((res) => {
            console.log(res.data);
            this.exportTable = res.data;
            this.value = "实时数据";
            this.HisTime = [];
            this.concentrationList1 = [];
            this.concentrationList2 = [];
            this.concentrationList3 = [];
            this.concentrationList4 = [];
            this.concentrationList5 = [];
            this.longitudeList = [];
            this.latitudeList = [];
            this.HLLlist = [];
            this.listdata1 = [];
            this.listdata2 = [];
            this.listdata3 = [];
            this.listdata4 = [];
            this.concentration1 = 0;
            this.concentration2 = 0;
            this.concentration3 = 0;
            this.concentration4 = 0;
            this.concentration5 = 0;
            for (let i = 5; i <= res.data.length - 1; i++) {
              this.Datahandle(res.data[i]);
              if (this.longitude != 0 && this.latitude != 0) {
                this.HLLlist.push([this.longitude, this.latitude]);
              }
            }
            //console.log(this.HLLlist);
            this.initMaps(0, 1, 1, 1, 1);
            if (this.optionMin) {
              this.optionMin.close();
            }
            this.refreshflag = false;
          });
        }
      }
    );

    this.username = this.$store.state.username; //将store里的用户名传到本组件
    //console.log(this.project);
    this.concentration1 = 0;
    this.concentration2 = 0;
    this.concentration3 = 0;
    this.concentration4 = 0;
    this.time = "2024/7/8 12:00:00";
    this.wind = 0;
    this.windspeed = 0;
    // this.latitude = 39.997245;
    // this.longitude = 116.333926;
    this.temperature = 0;
    this.pressure = 0;
  },
  mounted() {
    // 监听主界面的语言切换事件
    this.$bus.$on("language-changed", (flag) => {
      this.Lflag = flag;
    });
    // 隔1s刷新一次数据
    this.refreshData = setInterval(() => {
      if (this.refreshflag == true && this.init_flag == true) {
        askECOdata(this.$qs.stringify({ site: this.site })).then((res) => {
          if (!res || !res.data || !res.data[0]) return;
          if (res.data[0].infor != "Wrong data") {
            this.Datahandle(res.data[0]);
            if (this.start_flag == false) {
              this.DataTime[0] = this.time;
            } else {
              if (this.centerDialogVisible == false) {
                this.DataTime[1] = this.time;
              }
            }
            //console.log(this.DataTime[1]);
            //console.log([this.longitude, this.latitude]);
            if (this.longitude != 0 && this.latitude != 0) {
              this.HLLlist.push([this.longitude, this.latitude]);
            }
            this.refresh(4);
            if (this.showChart1 == true) {
              this.myChart1.setOption({
                series: [
                  {
                    data: this.listdata1,
                  },
                ],
              });
            }
            if (this.showChart2 == true) {
              this.myChart2.setOption({
                series: [
                  {
                    data: this.listdata2,
                  },
                ],
              });
            }
            if (this.showChart3 == true) {
              this.myChart3.setOption({
                series: [
                  {
                    data: this.listdata3,
                  },
                ],
              });
            }
            if (this.showChart4 == true) {
              this.myChart4.setOption({
                series: [
                  {
                    data: this.listdata4,
                  },
                ],
              });
            }
          }
          //this.indexList = res.data;
        });
      }

    }, 1000);
  },
  computed: {
    buttonStyle1() {
      return {
        top: this.isExpanded1 ? "auto" : "63.9%",
        bottom: this.isExpanded1 ? ".1075vw" : "auto",
        right: this.isExpanded1 ? "auto" : "57.8%",
        left: this.isExpanded1 ? ".1075vw" : "auto",
      };
    },
    arrowSymbol1() {
      return this.isExpanded1 ? "∧" : "∨";
    },
    buttonStyle2() {
      return {
        top: this.isExpanded2 ? "auto" : "63.9%",
        bottom: this.isExpanded2 ? ".1075vw" : "auto",
        right: this.isExpanded2 ? "auto" : "57.8%",
        left: this.isExpanded2 ? ".1075vw" : "auto",
      };
    },
    arrowSymbol2() {
      return this.isExpanded2 ? "∧" : "∨";
    },
    buttonStyle3() {
      return {
        top: this.isExpanded3 ? "auto" : "63.9%",
        bottom: this.isExpanded3 ? ".1075vw" : "auto",
        right: this.isExpanded3 ? "auto" : "57.8%",
        left: this.isExpanded3 ? ".1075vw" : "auto",
      };
    },
    arrowSymbol3() {
      return this.isExpanded3 ? "∧" : "∨";
    },
    buttonStyle4() {
      return {
        top: this.isExpanded4 ? "auto" : "63.9%",
        bottom: this.isExpanded4 ? ".1075vw" : "auto",
        right: this.isExpanded4 ? "auto" : "57.8%",
        left: this.isExpanded4 ? ".1075vw" : "auto",
      };
    },
    arrowSymbol4() {
      return this.isExpanded4 ? "∧" : "∨";
    },
  },
  methods: {
    beforeUpload(file) {
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        var text = "请上传PDF文件";
        if (this.Lflag == false) {
          text = "Please upload a PDF file";
        }
        this.optionMin = this.$message({
          showClose: true,
          message: text,
          duration: 2 * 1000,
          center: true,
          type: "error",
          customClass: "customclass",
        });
        return false;
      }
      return true;
    },
    customRequest(options) {
      const formData = new FormData();
      formData.append("file", options.file);
      formData.append("site", this.$store.state.site);
      formData.append("name", this.$store.state.eco_value);

      axios
        .post("/upload_ECO_report", formData, {
          headers: this.headers,
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            // 更新上传进度
            options.onProgress({ percent: percentCompleted });
          },
        })
        .then((res) => {
          console.log(res.data);
          if (res.data.length > 0) {
            var text = "上传成功";
            if (this.Lflag == false) {
              text = "The upload is successful";
            }
            this.optionMin = this.$message({
              showClose: true,
              message: text,
              duration: 2 * 1000,
              center: true,
              type: "success",
              customClass: "customclass",
            });
          }
        });
    },
    handleClick(tab) {
      if (tab.name == "first") {
        this.downloadmode = 1;
      } else if (tab.name == "second") {
        this.pdfname = "暂无走航报告";
        // 将 disabled 属性设置为 true
        this.downloadmode = 2;
        let url =
          "http://121.40.95.239:8088/download_ECO_report?" +
          "site=" +
          this.$store.state.site +
          "&name=" +
          this.$store.state.eco_value;
        // let a = document.createElement("a");
        // a.href = url;
        // a.click();
        axios
          .get("/download_ECO_report", {
            responseType: "blob", // 设置响应类型为 blob
            params: {
              site: this.$store.state.site,
              name: this.$store.state.eco_value,
            },
          })
          .then((response) => {
            const contentDisposition = response.headers["content-disposition"];
            this.pdfname = "downloaded_file.pdf";
            if (contentDisposition) {
              const match = contentDisposition.match(/filename="?([^"]+)"?/);
              if (match) {
                this.pdfname = decodeURIComponent(match[1]);
                this.pdfname = this.pdfname.replace(".pdf", "");
              }
            }

            this.pdflist = response.data;
            // 将 disabled 属性设置为 true
          })
          .catch((error) => {});
      } else if (tab.name == "third") {
        this.downloadmode = 3;
      }
    },
    download() {
      if (this.downloadmode == 1) {
        this.exportTableToExcel(this.exportTable, this.indexList);
      } else if (this.downloadmode == 2) {
        console.log(this.pdflist);
        const url = window.URL.createObjectURL(new Blob([this.pdflist]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", this.pdfname + ".pdf"); // 设置下载文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    set_chat(id) {
      if (id == 1) {
        if (this.showChart1 == true) {
          this.showChart1 = false;
          this.isExpanded1 = true;
          this.myChart1.dispose();
        } else {
          this.showChart1 = true;
          this.isExpanded1 = false;
          this.draw_list(1);
        }
      } else if (id == 2) {
        if (this.showChart2 == true) {
          this.showChart2 = false;
          this.isExpanded2 = true;
          this.myChart2.dispose();
        } else {
          this.showChart2 = true;
          this.isExpanded2 = false;
          this.draw_list(2);
        }
      } else if (id == 3) {
        if (this.showChart3 == true) {
          this.showChart3 = false;
          this.isExpanded3 = true;
          this.myChart3.dispose();
        } else {
          this.showChart3 = true;
          this.isExpanded3 = false;
          this.draw_list(3);
        }
      } else if (id == 4) {
        if (this.showChart4 == true) {
          this.showChart4 = false;
          this.isExpanded4 = true;
          this.myChart4.dispose();
        } else {
          this.showChart4 = true;
          this.isExpanded4 = false;
          this.draw_list(4);
        }
      }
    },

    gear_compute(list_temp) {
      console.log(list_temp);
      var temp;
      var list = [];
      var standard = [];
      var sum = 0;
      for (let i = 0; i < list_temp.length; i++) {
        if (list_temp[i] < 0) {
          sum += 0;
        } else {
          sum += list_temp[i];
        }
      }
      const average = sum / list_temp.length;
      console.log(average);
      for (let i = 0; i < list_temp.length; i++) {
        if (list_temp[i] < 5 * average) {
          if (list_temp[i] < 0) {
            list.push(0);
          } else {
            list.push(list_temp[i]);
          }
        }
      }
      console.log(Math.max(...list), average);
      temp = Math.max(...list) - average;
      standard[0] = average.toFixed(2);
      standard[1] = (average + temp * 0.225).toFixed(2);
      standard[2] = (average + temp * 0.45).toFixed(2);
      standard[3] = (average + temp * 0.675).toFixed(2);
      standard[4] = (average + temp * 0.9).toFixed(2);
      console.log(standard);
      return standard;
    },
    reset_gears() {
      console.log(this.gears_reset);
      if (this.gears_reset == false) {
        this.standard1 = [2100, 2200, 2500, 3000, 4000]; //浓度1浓度挡位
        this.standard2 = [350, 370, 400, 450, 500]; //浓度2浓度挡位
        this.standard3 = [400, 500, 700, 1000, 1500]; //浓度3浓度挡位
        this.standard4 = [20, 50, 100, 200, 400]; //浓度4浓度挡位
      } else {
        if (this.concentrationList1.length > 5) {
          this.standard1 = this.gear_compute(this.concentrationList1);
        }
        if (this.concentrationList2.length > 5) {
          this.standard2 = this.gear_compute(this.concentrationList2);
        }
        if (this.concentrationList3.length > 5) {
          this.standard3 = this.gear_compute(this.concentrationList3);
        }
        if (this.concentrationList4.length > 5) {
          this.standard4 = this.gear_compute(this.concentrationList4);
        }
      }
    },
    menuChange(name) {
      const item = this.options.find(o => o.name === name);
      if (item) {
        this.HisTime[0] = item.start;
        this.HisTime[1] = item.end;
      }
      this.key += 1;
      console.log(this.HisTime);
    },
    his_click() {
      this.DataHis_flag = true;
      this.key += 1;
      get_time_lag(this.$qs.stringify({ site: this.$store.state.site })).then(
        (res) => {
          this.options = res.data;
          this.options.unshift({ name: "实时数据", start: "", end: "" });
          console.log(this.options);
          // 选项加载完后预选当前使用的数据
          const currentName = this.$store.state.eco_value;
          if (currentName) {
            this.value = currentName;
            const currentTime = this.$store.state.eco_time || [];
            this.HisTime = [...currentTime];
          } else {
            this.value = this.options[this.options.length - 1].name;
          }
        }
      );
    },
    hisData() {
      var text = "数据加载中";
      if (this.Lflag == false) {
        text = "The data is loading";
      }
      this.optionMin = this.$message({
        showClose: true,
        message: text,
        duration: 30 * 1000,
        center: true,
        type: "success",
        customClass: "customclass",
      });
      console.log(this.value);
      if (this.value != "实时数据") {
        select_data_by_time(
          this.$qs.stringify({
            start: this.HisTime[0],
            end: this.HisTime[1],
            table: this.$store.state.site,
          })
        ).then((res) => {
          console.log(res.data);
          this.exportTable = res.data;
          this.$store.commit("seteco_value", this.value);
          this.$store.commit("seteco_time", this.HisTime);
          this.value = "实时数据";
          this.HisTime = [];
          this.concentrationList1 = [];
          this.concentrationList2 = [];
          this.concentrationList3 = [];
          this.concentrationList4 = [];
          this.concentrationList5 = [];
          this.longitudeList = [];
          this.latitudeList = [];
          this.HLLlist = [];
          this.listdata1 = [];
          this.listdata2 = [];
          this.listdata3 = [];
          this.listdata4 = [];
          this.concentration1 = 0;
          this.concentration2 = 0;
          this.concentration3 = 0;
          this.concentration4 = 0;
          this.concentration5 = 0;
          for (let i = 5; i <= res.data.length - 1; i++) {
            this.Datahandle(res.data[i]);
            if (this.longitude != 0 && this.latitude != 0) {
              this.HLLlist.push([this.longitude, this.latitude]);
            }
          }
          // console.log(this.HLLlist);
          this.reset_gears();
          //console.log(this.HLLlist);
          this.initMaps(1, 1, 1, 1, 1);
          if (this.optionMin) {
            this.optionMin.close();
          }
          this.refreshflag = false;
        });
      } else {
        askhistory_by_end_time(
          this.$qs.stringify({ site: this.$store.state.site })
        ).then((res) => {
          this.exportTable = res.data;
          this.$store.commit("seteco_value", this.value);
          this.value = this.options[this.options.length - 1].name;
          this.HisTime[0] = this.options[this.options.length - 1].start;
          this.HisTime[1] = this.options[this.options.length - 1].end;
          this.concentrationList1 = [];
          this.concentrationList2 = [];
          this.concentrationList3 = [];
          this.concentrationList4 = [];
          this.concentrationList5 = [];
          this.longitudeList = [];
          this.latitudeList = [];
          this.HLLlist = [];
          this.listdata1 = [];
          this.listdata2 = [];
          this.listdata3 = [];
          this.listdata4 = [];
          this.concentration1 = 0;
          this.concentration2 = 0;
          this.concentration3 = 0;
          this.concentration4 = 0;
          this.concentration5 = 0;
          console.log(res.data);
          for (let i = 5; i <= res.data.length - 1; i++) {
            this.Datahandle(res.data[i]);
            if (i == 5) {
              this.DataTime[0] = this.time;
              this.start_flag = true;
              console.log(this.time);
            } else if (i == res.data.length - 1) {
              this.DataTime[1] = this.time;
            }
            if (this.longitude != 0 && this.latitude != 0) {
              this.HLLlist.push([this.longitude, this.latitude]);
            }
          }
          //console.log(this.HLLlist);
          this.initMaps(1, 1, 1, 1, 1);
          if (this.optionMin) {
            this.optionMin.close();
          }
          this.refreshflag = true;
        });
      }

      this.DataHis_flag = false;
    },
    resetmap() {
      console.log(this.name, this.DataTime);
      setstart(
        this.$qs.stringify({
          database: this.database,
          site: this.$store.state.site,
          start: this.DataTime[0],
          name: this.name,
        })
      ).then((res) => {
        console.log(res);
        var stamp = new Date().getTime() + 8 * 60 * 60 * 1000;
        // 格式化北京时间为"YYYY-MM-DD HH:mm:ss"
        var beijingTime = new Date(stamp)
          .toISOString()
          .replace(/T/, " ")
          .replace(/\..+/, "")
          .substring(0, 19);
        console.log(beijingTime, this.DataTime[1]);
        setend(
          this.$qs.stringify({
            database: this.database,
            site: this.$store.state.site,
            end: this.DataTime[1],
            name: this.name,
            data_end: beijingTime,
          })
        ).then((res) => {
          console.log(res);
        });
      });
      this.concentrationList1 = [];
      this.concentrationList2 = [];
      this.concentrationList3 = [];
      this.concentrationList4 = [];
      this.concentrationList5 = [];
      this.longitudeList = [];
      this.latitudeList = [];
      this.HLLlist = [];
      this.listdata1 = [];
      this.listdata2 = [];
      this.listdata3 = [];
      this.listdata4 = [];
      this.concentration1 = 0;
      this.concentration2 = 0;
      this.concentration3 = 0;
      this.concentration4 = 0;
      this.concentration5 = 0;
      this.refreshflag = false;
      this.initMaps(1, 1, 1, 1, 1);
      this.refreshflag = true;
      this.centerDialogVisible = false;
    },
    alarmhandle(alarm, hex, state) {
      let binary = parseInt(hex, 16).toString(2);
      let num = 1;
      if (state == false) {
        num = 17;
      }
      for (let i = binary.length - 1; i >= 0; i--) {
        if (binary[i] == 1) {
          if (alarm == 0) {
            alarm = num;
          } else {
            alarm = alarm + "," + num;
          }
        }
        num++;
      }
      return alarm;
    },
    // ─── 工具方法 ───────────────────────────────────────────────
    _getGearColor(conc, std) {
      if (conc >= std[4]) return this.standard_color[5];
      if (conc >= std[3]) return this.standard_color[4];
      if (conc >= std[2]) return this.standard_color[3];
      if (conc >= std[1]) return this.standard_color[2];
      if (conc >= std[0]) return this.standard_color[1];
      return this.standard_color[0];
    },
    _heatColorFor(weight) {
      const heatColors = ['rgba(6,234,119,0.5)','rgba(234,199,6,0.5)','rgba(234,156,6,0.5)','rgba(230,4,4,0.5)','rgba(163,4,15,0.5)','rgba(146,2,151,0.5)'];
      const idx = Math.min(heatColors.length - 1, Math.floor(weight * heatColors.length));
      return heatColors[idx];
    },
    _colorCSS(ca) {
      return (
        "rgba(" +
        Math.round(ca[0] * 255) + "," +
        Math.round(ca[1] * 255) + "," +
        Math.round(ca[2] * 255) + "," +
        this.alphaValue / 100 + ")"
      );
    },

    // ─── 天地图图层工厂 ──────────────────────────────────────────
    _makeTdtLayers() {
      const key = this.tdtKey;
      return [
        new TileLayer({
          source: new XYZ({
            url: `https://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${key}`,
            crossOrigin: "anonymous",
          }),
        }),
        new TileLayer({
          source: new XYZ({
            url: `https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${key}`,
            crossOrigin: "anonymous",
          }),
        }),
      ];
    },

    // ─── 创建单个地图实例 ──────────────────────────────────────
    _createOneMap(containerId, concSourceRef, heatSourceRef) {
      const concSource = new VectorSource();
      const heatSource = new VectorSource();
      const routeSource = new VectorSource();

      // 彩色浓度线图层
      const concLayer = new VectorLayer({
        source: concSource,
        visible: this.showColorLine,
      });
      // 热力图图层
      const heatLayer = new VectorLayer({
        source: heatSource,
        style: new Style({ image: new Circle({ radius: 8, fill: new Fill({ color: '#06EA77' }) }) }),
        visible: this.showHeatmap,
      });
      this['heatLayer' + containerId.replace('container','')] = heatLayer;
      // 路线轨迹图层（青色底线）
      const routeLayer = new VectorLayer({ source: routeSource });

      const center = fromLonLat([
        this.longitude || 116.33,
        this.latitude  || 39.99,
      ]);
      const map = new Map({
        target: containerId,
        layers: [
          ...this._makeTdtLayers(),
          routeLayer,
          concLayer,
          heatLayer,
        ],
        view: new View({ center, zoom: 16 }),
      });
      // 等 DOM 布局完成后刷新地图尺寸
      requestAnimationFrame(() => {
        map.updateSize();
        setTimeout(() => map.updateSize(), 100);
      });


      // 鼠标悬停显示浓度
      const unitMap = { container1: 'ppb', container2: 'ppb', container3: 'ppm', container4: 'ppb' };
      const unit = unitMap[containerId] || 'ppb';
      const popup = document.createElement('div');
      popup.className = 'ol-popup';
      popup.style.cssText = 'position:absolute;background:rgba(0,0,0,0.75);color:#fff;padding:4px 8px;border-radius:4px;font-size:12px;pointer-events:none;z-index:1000;display:none;white-space:nowrap';
      document.getElementById(containerId).appendChild(popup);

      // 创建不可见的轨道点图层用于鼠标检测
      const hoverSource = new VectorSource();
      // 存原始投影坐标和浓度值用于鼠标悬停（纯距离计算，不依赖图层命中检测）
      let hoverPoints = [];
      let hoverConcs = [];
      this['_updateHoverData' + containerId.slice(-1)] = (pts, concs) => {
        hoverPoints = pts.map(p => fromLonLat(p));
        hoverConcs = concs.slice();
      };

      map.on('pointermove', (evt) => {
        if (hoverPoints.length === 0) { popup.style.display = 'none'; return; }
        const mx = evt.coordinate[0], my = evt.coordinate[1];
        const pxThreshold = 12;
        const meterThreshold = pxThreshold * (map.getView().getResolution() || 1);
        let minDist = Infinity, minIdx = -1;
        for (let i = 0; i < hoverPoints.length; i++) {
          const dx = hoverPoints[i][0] - mx;
          const dy = hoverPoints[i][1] - my;
          const d2 = dx * dx + dy * dy;
          if (d2 < minDist) { minDist = d2; minIdx = i; }
        }
        if (minIdx >= 0 && Math.sqrt(minDist) <= meterThreshold) {
          const pixel = map.getPixelFromCoordinate(hoverPoints[minIdx]);
          popup.textContent = (hoverConcs[minIdx] || 0).toFixed(1) + ' ' + unit;
          popup.style.left = (pixel[0] + 12) + 'px';
          popup.style.top = (pixel[1] - 24) + 'px';
          popup.style.display = '';
        } else {
          popup.style.display = 'none';
        }
      });

      // 回写 source 引用
      this[concSourceRef] = concSource;
      this[heatSourceRef] = heatSource;
      return { map, routeSource };
    },

    // ─── 初始化全部地图 ────────────────────────────────────────
    initMaps(id, id1, id2, id3, id4) {
      // id=1 表示重新初始化（销毁旧实例）；id=0 表示首次
      const destroy = (m) => { if (m) { m.setTarget(null); } };
      if (id === 1) {
        destroy(this.olMap1); destroy(this.olMap2);
        destroy(this.olMap3); destroy(this.olMap4);
        this.olMap1 = this.olMap2 = this.olMap3 = this.olMap4 = null;
      }
      this.$nextTick(() => {
        if (id1 === 1) {
          const r = this._createOneMap("container1", "concSource1", "heatSource1");
          if (r) { this.olMap1 = r.map; this._routeSource1 = r.routeSource; }
        }
        if (id2 === 1) {
          const r = this._createOneMap("container2", "concSource2", "heatSource2");
          if (r) { this.olMap2 = r.map; this._routeSource2 = r.routeSource; }
        }
        if (id3 === 1) {
          const r = this._createOneMap("container3", "concSource3", "heatSource3");
          if (r) { this.olMap3 = r.map; this._routeSource3 = r.routeSource; }
        }
        if (id4 === 1) {
          const r = this._createOneMap("container4", "concSource4", "heatSource4");
          if (r) { this.olMap4 = r.map; this._routeSource4 = r.routeSource; }
        }
        // 等地图渲染完成后绘制历史数据
        this.$nextTick(() => {
          this.resetwall(id1, id2, id3, id4);
          this._drawRoutes(id1, id2, id3, id4);
          this.draw_list(1);
          this.draw_list(2);
          this.draw_list(3);
          this.draw_list(4);
          this.init_flag = true;
        });
      });
    },

    // ─── 数据解析（GPS坐标直接用WGS84，天地图支持WGS84）───────
    Datahandle(list) {
      var refresh = false;
      this.time = list.time;
      if (list.wd !== undefined) this.wind = list.wd;
      if (list.ws !== undefined) this.windspeed = list.ws;
      if (list.T !== undefined) this.temperature = list.T;
      this.ch4_alarm = 0;
      this.n2o_alarm = 0;
      this.nh3_alarm = 0;
      for (let k in list) {
        for (let i = 0; i < this.indexList.length; i++) {
          if (k == this.indexList[i].paramIndex) {
            const pn = this.indexList[i].paramName;
            if (pn === "longitude") {
              this.longitudeList.push(list[k]);
              this.longitude = list[k];
              refresh = true;
            } else if (pn === "latitude") {
              this.latitudeList.push(list[k]);
              this.latitude = list[k];
            } else if (pn === "drive_direction") {
              this.drive_direction = list[k];
            } else if (pn === "car_speed") {
              this.car_speed = list[k];
            } else if (pn === "CH4concentration_ppb") {
              this.concentrationList1.push(list[k]);
              this.concentration1 = list[k];
              this.listdata1.push([this.time, this.concentration1]);
            } else if (pn === "N2Oconcentration_ppb") {
              this.concentrationList2.push(list[k]);
              this.concentration2 = list[k];
              this.listdata2.push([this.time, this.concentration2]);
            } else if (pn === "CO2concentration_ppm") {
              this.concentrationList3.push(list[k]);
              this.concentration3 = list[k];
              this.listdata3.push([this.time, this.concentration3]);
            } else if (pn === "H2Oconcentration_ppm") {
              this.concentrationList5.push(list[k]);
              this.concentration5 = list[k];
            } else if (pn === "NH3concentration_ppb") {
              this.concentrationList4.push(list[k]);
              this.concentration4 = list[k];
              this.listdata4.push([this.time, this.concentration4]);
            } else if (pn === "pressure_kpa") {
              this.pressure = list[k];
            } else if (pn === "8600_OSS") {
              this.oss_ch4 = list[k];
            } else if (pn === "8600_low_alarm") {
              this.ch4_alarm = this.alarmhandle(this.ch4_alarm, list[k], true);
            } else if (pn === "8600_high_alarm") {
              this.ch4_alarm = this.alarmhandle(this.ch4_alarm, list[k], false);
            } else if (pn === "8700_OSS") {
              this.oss_nh3 = list[k];
            } else if (pn === "8700_low_alarm") {
              this.nh3_alarm = this.alarmhandle(this.nh3_alarm, list[k], true);
            } else if (pn === "8700_high_alarm") {
              this.nh3_alarm = this.alarmhandle(this.nh3_alarm, list[k], false);
            } else if (pn === "8500_OSS") {
              this.oss_n2o = list[k];
            } else if (pn === "8500_low_alarm") {
              this.n2o_alarm = this.alarmhandle(this.n2o_alarm, list[k], true);
            } else if (pn === "8500_high_alarm") {
              this.n2o_alarm = this.alarmhandle(this.n2o_alarm, list[k], false);
            }
          }
        }
      }
      // WGS84 直接使用，不再转高德坐标
      if (this.latitude != 0 && this.longitude != 0 && refresh) {
        if (this.LLlist.length === 0) {
          this.LLlist[0] = [this.longitude, this.latitude];
        } else if (this.LLlist.length === 1) {
          this.LLlist[1] = [this.longitude, this.latitude];
          this.temp = [this.longitude, this.latitude];
        } else {
          this.LLlist[0] = this.temp;
          this.LLlist[1] = [this.longitude, this.latitude];
        }
        this.temp = [this.longitude, this.latitude];
      }
    },

    // ─── 实时刷新（每秒调用）──────────────────────────────────
    refresh(id) {
      // 更新路线轨迹
      this._drawRoutes(1, 1, 1, 1);
      // 追加最新一段彩色线
      const appendSeg = (src, list, std, pts) => {
        if (!src || pts.length < 2) return;
        const i = pts.length - 2;
        const p1 = pts[i], p2 = pts[i + 1];
        const ca = this._getGearColor(list[i] || 0, std);
        const f = new Feature({
          geometry: new LineString([fromLonLat(p1), fromLonLat(p2)]),
        });
        f.setStyle(
          new Style({
            stroke: new Stroke({
              color: this._colorCSS(ca),
              width: 3.5 + ((list[i] || 0) / std[4]) * 3,
            }),
          })
        );
        src.addFeature(f);
      };
      const pts = this.HLLlist || [];
      appendSeg(this.concSource1, this.concentrationList1, this.standard1, pts);
      appendSeg(this.concSource2, this.concentrationList2, this.standard2, pts);
      appendSeg(this.concSource3, this.concentrationList3, this.standard3, pts);
      appendSeg(this.concSource4, this.concentrationList4, this.standard4, pts);
      // 追加热力图点（带配色+网格聚合级颜色）
      const appendHeat = (src, list, std, pts) => {
        if (!src || pts.length === 0) return;
        const i = pts.length - 1;
        const conc = list[i] || 0;
        const f = new Feature({ geometry: new Point(fromLonLat(pts[i])) });
        const weight = Math.min(conc / (std[4] || 1), 1);
        f.setStyle(new Style({ image: new Circle({ radius: 4 + weight * 12, fill: new Fill({ color: this._heatColorFor(weight) }) }) }));
        src.addFeature(f);
      };
      appendHeat(this.heatSource1, this.concentrationList1, this.standard1, pts);
      appendHeat(this.heatSource2, this.concentrationList2, this.standard2, pts);
      appendHeat(this.heatSource3, this.concentrationList3, this.standard3, pts);
      appendHeat(this.heatSource4, this.concentrationList4, this.standard4, pts);

      // 同步更新 hover 悬浮数据（把最新点也喂进去）
      const hoverCfg = [
        [1, this.concentrationList1],
        [2, this.concentrationList2],
        [3, this.concentrationList3],
        [4, this.concentrationList4],
      ];
      for (const [qid, list] of hoverCfg) {
        if (typeof this['_updateHoverData' + qid] === 'function') {
          const n = Math.min(pts.length, list.length);
          this['_updateHoverData' + qid](pts.slice(0, n), list.slice(0, n));
        }
      }

    },

    // ─── 全量重绘彩色线（历史数据加载后调用）──────────────────
    resetwall(id1, id2, id3, id4) {
      if (id1 == 1 && this.concSource1) this.concSource1.clear();
      if (id2 == 1 && this.concSource2) this.concSource2.clear();
      if (id3 == 1 && this.concSource3) this.concSource3.clear();
      if (id4 == 1 && this.concSource4) this.concSource4.clear();
      this._drawHeatmap(id1, id2, id3, id4);
      const cfg = [
        [1, this.concSource1, this.concentrationList1, this.standard1],
        [2, this.concSource2, this.concentrationList2, this.standard2],
        [3, this.concSource3, this.concentrationList3, this.standard3],
        [4, this.concSource4, this.concentrationList4, this.standard4],
      ];
      const active = { 1: id1, 2: id2, 3: id3, 4: id4 };
      const pts = this.HLLlist || [];
      if (pts.length < 2) return;
      for (const [qid, src, list, std] of cfg) {
        if (active[qid] !== 1 || !src || !list) continue;
        const feats = [];
        const len = Math.min(list.length, pts.length - 1);
        for (let i = 0; i < len; i++) {
          const p1 = pts[i], p2 = pts[i + 1];
          if (!p1 || !p2) continue;
          const ca = this._getGearColor(list[i] || 0, std);
          const f = new Feature({
            geometry: new LineString([fromLonLat(p1), fromLonLat(p2)]),
          });
          f.setStyle(
            new Style({
              stroke: new Stroke({
                color: this._colorCSS(ca),
                width: 3.5 + ((list[i] || 0) / std[4]) * 3,
              }),
            })
          );
          feats.push(f);
        }
        src.addFeatures(feats);
      }
    },

    // ─── 全量重绘热力图（历史数据加载后调用）──────────────────
    // ─── 网格聚合：同一格内的点取平均权重，避免叠加变亮 ───
    _gridAverage(pts, weights, cellSize) {
      // 先批量转换所有点坐标，避免循环内重复 fromLonLat 调用
      const projected = pts.map(p => fromLonLat(p));
      const cells = {};
      for (let i = 0; i < pts.length; i++) {
        const [x, y] = projected[i];
        const key = Math.floor(x / cellSize) + '_' + Math.floor(y / cellSize);
        if (!cells[key]) { cells[key] = { sumW: 0, count: 0, sumX: 0, sumY: 0 }; }
        const c = cells[key];
        c.sumW += weights[i];
        c.count++;
        c.sumX += x;
        c.sumY += y;
      }
      const feats = [];
      Object.keys(cells).forEach((key) => {
        const c = cells[key];
        const avgW = c.sumW / c.count;
        const f = new Feature({ geometry: new Point([c.sumX / c.count, c.sumY / c.count]) });
        f.setStyle(new Style({ image: new Circle({ radius: 4 + avgW * 12, fill: new Fill({ color: this._heatColorFor(avgW) }) }) }));
        feats.push(f);
      });
      return feats;
    },

    // ─── 绘制热力图（含网格聚合） ────────────────────────
    _drawHeatmap(id1, id2, id3, id4) {
      const cfg = [
        [1, this.heatSource1, this.concentrationList1, this.standard1],
        [2, this.heatSource2, this.concentrationList2, this.standard2],
        [3, this.heatSource3, this.concentrationList3, this.standard3],
        [4, this.heatSource4, this.concentrationList4, this.standard4],
      ];
      const active = { 1: id1, 2: id2, 3: id3, 4: id4 };
      const pts = this.HLLlist || [];
      for (const [qid, src, list, std] of cfg) {
        if (active[qid] !== 1 || !src || !list || pts.length === 0) continue;
        const n = Math.min(list.length, pts.length);
        const weights = new Array(n);
        for (let i = 0; i < n; i++) {
          weights[i] = Math.min((list[i] || 0) / (std[4] || 1), 1);
        }
        // 网格聚合（15米一格），再喂给热力图
        const feats = this._gridAverage(pts.slice(0, n), weights, 15);
        src.clear();
        src.addFeatures(feats);
      }
      // 同步 hover 检测图层
      for (const [qid, , list] of cfg) {
        if (active[qid] !== 1 || !list || pts.length === 0) continue;
        if (typeof this['_updateHoverData' + qid] === 'function') {
          const n = Math.min(pts.length, list.length);
          this['_updateHoverData' + qid](pts.slice(0, n), list.slice(0, n));
        }
      }
    },

    // ─── 轨迹底线 ───────────────────────────────────────────────
    _drawRoutes(id1, id2, id3, id4) {
      const pts = this.HLLlist || [];
      if (pts.length < 2) return;
      const coords = pts.map((p) => fromLonLat(p));
      const feat = new Feature({ geometry: new LineString(coords) });
      feat.setStyle(
        new Style({ stroke: new Stroke({ color: "#29e2e5", width: 2 }) })
      );
      const maps = [
        [1, this.olMap1, this._routeSource1],
        [2, this.olMap2, this._routeSource2],
        [3, this.olMap3, this._routeSource3],
        [4, this.olMap4, this._routeSource4],
      ];
      const flags = { 1: id1, 2: id2, 3: id3, 4: id4 };
      for (const [i, m, rs] of maps) {
        if (flags[i] !== 1 || !m || !rs) continue;
        rs.clear();
        rs.addFeature(feat.clone());
      }
    },



    // ─── 热力图/彩色线 显示切换 ────────────────────────────────
    toggleHeatmap() {
      this.showHeatmap = !this.showHeatmap;
      [this.olMap1, this.olMap2, this.olMap3, this.olMap4].forEach((m) => {
        if (!m) return;
        m.getLayers().getArray().forEach((l) => {
          if (l === this['heatLayer1'] || l === this['heatLayer2'] || l === this['heatLayer3'] || l === this['heatLayer4']) l.setVisible(this.showHeatmap);
        });
      });
    },
    toggleColorLine() {
      this.showColorLine = !this.showColorLine;
      [this.olMap1, this.olMap2, this.olMap3, this.olMap4].forEach((m) => {
        if (!m) return;
        m.getLayers().getArray().forEach((l) => {
          if (l instanceof VectorLayer && l.getSource() instanceof VectorSource) {
            if (l.getSource() === this.concSource1 ||
                l.getSource() === this.concSource2 ||
                l.getSource() === this.concSource3 ||
                l.getSource() === this.concSource4) {
              l.setVisible(this.showColorLine);
            }
          }
        });
      });
    },

    // ─── echarts 折线图 ─────────────────────────────────────────
    draw_list(index) {
      function fontSize(res) {
        let clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
        if (!clientWidth) return res;
        return res * (clientWidth / 1860);
      }
      const size = this.zoomflag ? 8 : 12;
      let data = [], lable = "";
      let chartDom = null, chartRef = null;
      if (index === 1) {
        chartDom = document.getElementById("lineChart1");
        data = this.listdata1; lable = this.lable1; chartRef = "myChart1";
      } else if (index === 2) {
        chartDom = document.getElementById("lineChart2");
        data = this.listdata2; lable = this.lable2; chartRef = "myChart2";
      } else if (index === 3) {
        chartDom = document.getElementById("lineChart3");
        data = this.listdata3; lable = this.lable3; chartRef = "myChart3";
      } else if (index === 4) {
        chartDom = document.getElementById("lineChart4");
        data = this.listdata4; lable = this.lable4; chartRef = "myChart4";
      }
      if (this[chartRef] && typeof this[chartRef].dispose === 'function') this[chartRef].dispose();
      this[chartRef] = echarts.init(chartDom);
      const convertedData = data.map((item) => [new Date(item[0]).getTime(), item[1]]);
      const option = {
        grid: { top: "15%", bottom: "5%", left: "10%", right: "10%", containLabel: true },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow", label: { backgroundColor: "#6a7985" } },
          textStyle: { fontSize: fontSize(size + 4) },
        },
        dataZoom: [{ type: "inside" }],
        xAxis: {
          type: "time",
          splitLine: { show: false },
          nameGap: fontSize(5),
          axisLabel: { rotate: 30, fontSize: fontSize(size) },
          name: "time",
          nameTextStyle: { fontSize: fontSize(size) },
        },
        yAxis: {
          name: lable,
          nameGap: fontSize(5),
          type: "value",
          boundaryGap: [0, "100%"],
          axisLabel: { fontSize: fontSize(size) },
          splitLine: { show: true },
          nameTextStyle: { fontSize: fontSize(size) },
          scale: true,
        },
        series: [{ name: lable, type: "line", showSymbol: false, data: convertedData }],
      };
      this[chartRef].setOption(option);
      window.addEventListener("resize", () => { if (this[chartRef]) this[chartRef].resize(); });
    },

    // ─── Excel 导出 ──────────────────────────────────────────────
    exportTableToExcel(tableData, headerDefinitions) {
      var str = this.filename + ".xlsx";
      headerDefinitions.unshift(
        { paramIndex: "id", paramName: "Id" },
        { paramIndex: "time", paramName: "time" }
      );
      const XLSX = require("xlsx");
      const workbook = XLSX.utils.book_new();
      const headers = headerDefinitions.map((def) => def.paramName);
      const dataRows = tableData.map((row) =>
        headerDefinitions.map((def) => row[def.paramIndex])
      );
      const worksheetData = [headers, ...dataRows];
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = str; a.click();
      window.URL.revokeObjectURL(url);
    },

    // ─── 下载按钮（打开导出弹窗） ────────────────────────────
    setfilename() {
      this.filename = this.$store.state.eco_value || "走航数据";
      this.exportflag = true;
    },

    // ─── 单地图全屏/还原 ────────────────────────────────────
    shrink() {
      this.color_flag1 = true;
      this.color_flag2 = true;
      this.color_flag3 = true;
      this.color_flag4 = true;
      // 还原所有图表
      this.showChart1 = true;
      this.showChart2 = true;
      this.showChart3 = true;
      this.showChart4 = true;

      // 还原 wrapper 高度
      const wrap = document.getElementById('map-area-wrapper');
      if (wrap && wrap._origHeight !== undefined) {
        wrap.style.height = wrap._origHeight;
        delete wrap._origHeight;
      }

      // 还原所有容器（简化版，删掉从未生效的死代码分支）
      for (let i = 1; i <= 4; i++) {
        const el = document.getElementById('con' + i);
        if (!el) continue;
        el.style.position = 'relative';
        el.style.float = 'left';
        el.style.margin = '';
        el.style.width = el._origWidth !== undefined ? el._origWidth : '47%';
        el.style.height = el._origHeight !== undefined ? el._origHeight : '30vh';
        el.style.top = el._origTop !== undefined ? el._origTop : '';
        delete el._origWidth;
        delete el._origHeight;
        delete el._origTop;
        // 还原父行包装器
        const parent = el.parentElement;
        if (parent && parent._origHeight !== undefined) {
          parent.style.height = parent._origHeight;
          delete parent._origHeight;
        }
        // 刷新 OL 地图
        const map = this['olMap' + i];
        if (map) {
          requestAnimationFrame(() => {
            map.updateSize();
            setTimeout(() => map.updateSize(), 100);
          });
        }
      }

      // 还原被放大地图的颜色图例
      const vcs = document.getElementById('VerticalColorScale' + this.zoom_num);
      if (vcs) { vcs.style.width = '3.3vw'; vcs.style.height = '15vh'; }

      // 还原地图 +/- 缩放控件位置
      const olZoom = document.querySelector('#con' + this.zoom_num + ' .ol-zoom');
      if (olZoom && olZoom._origTop !== undefined) {
        olZoom.style.top = olZoom._origTop;
        delete olZoom._origTop;
      }

      this.zoomflag = true;
      this.zoom_num = 0;

      // 还原折线图尺寸 + 重绘
      for (let i = 1; i <= 4; i++) {
        const lc = document.getElementById('lineChart' + i);
        if (lc) { lc.style.width = '14.3011vw'; lc.style.height = '11.7vh'; }
        const myChartKey = 'myChart' + i;
        if (this[myChartKey] && typeof this[myChartKey].dispose === 'function') { this[myChartKey].dispose(); this[myChartKey] = null; }
        this.draw_list(i);
      }
    },
    magnify(id) {
      this.zoom_num = Number(id); // 统一转数字（模板传的是字符串 '1'）
      // 收起所有图表
      this.showChart1 = true;
      this.showChart2 = true;
      this.showChart3 = true;
      this.showChart4 = true;
      // 只展开当前放大地图的
      if (this.zoom_num == 1) {
        this.color_flag1 = true;
        this.color_flag2 = false;
        this.color_flag3 = false;
        this.color_flag4 = false;
      } else if (this.zoom_num == 2) {
        this.color_flag1 = false;
        this.color_flag2 = true;
        this.color_flag3 = false;
        this.color_flag4 = false;
      } else if (this.zoom_num == 3) {
        this.color_flag1 = false;
        this.color_flag2 = false;
        this.color_flag3 = true;
        this.color_flag4 = false;
      } else if (this.zoom_num == 4) {
        this.color_flag1 = false;
        this.color_flag2 = false;
        this.color_flag3 = false;
        this.color_flag4 = true;
      }
      this.zoomflag = false;

      // 放大地图容器
      const el = document.getElementById('con' + this.zoom_num);
      if (!el) return;

      // 保存原始尺寸
      el._origWidth = el.style.width || '';
      el._origHeight = el.style.height || '';

      // 用绝对定位固定到 wrapper 左上角，确保任何位置的图放大后都居中
      const wrapper = document.getElementById('map-area-wrapper');
      if (wrapper) {
        wrapper._origHeight = wrapper.style.height || '';
        wrapper.style.height = '65vh';
      }
      el.style.cssText = 'width:71.5806vw;height:61vh;position:absolute;top:4vh;left:0';

      // 把地图的 +/- 缩放按钮往下移，不被关闭按钮盖住
      const olZoom = el.querySelector('.ol-zoom');
      if (olZoom) { olZoom._origTop = olZoom.style.top || ''; olZoom.style.top = '3.5em'; }

      // 隐藏其他容器
      for (let i = 1; i <= 4; i++) {
        if (i === this.zoom_num) continue;
        const other = document.getElementById('con' + i);
        if (other) { other.style.cssText = 'width:0;height:0;position:relative;float:left'; }
      }

      // 放大颜色图例 + 折线图
      const vcs = document.getElementById('VerticalColorScale' + this.zoom_num);
      if (vcs) { vcs.style.cssText = vcs.style.cssText.replace(/width:[^;]+/,'width:5.6vw').replace(/height:[^;]+/,'height:30vh'); }
      const lc = document.getElementById('lineChart' + this.zoom_num);
      if (lc) { lc.style.cssText = 'width:31vw;height:23vh'; }
      const myChartKey = 'myChart' + this.zoom_num;
      try {
        if (this[myChartKey] && typeof this[myChartKey].dispose === 'function') { this[myChartKey].dispose(); this[myChartKey] = null; }
        this.draw_list(this.zoom_num);
      } catch(e) { console.warn('chart:', e.message); }

      // 让 OL 重绘
      requestAnimationFrame(() => {
        const map = this['olMap' + this.zoom_num];
        if (map) map.updateSize();
        setTimeout(() => {
          const map2 = this['olMap' + this.zoom_num];
          if (map2) map2.updateSize();
        }, 100);
      });
    },
    // ─── 删除历史记录（非3D功能）─────────────────────
    delete_his(flag) {
      if (flag == false) {
        if (this.value == null) {
          var text = "未选择记录";
          if (this.Lflag == false) {
            text = "No record selected";
          }
          this.optionMin = this.$message({
            showClose: true,
            message: text,
            duration: 3 * 1000,
            center: true,
            type: "warning",
            customClass: "customclass",
          });
        } else if (this.value == "实时数据") {
          var text = "实时数据无法删除，请选择正确的记录";
          if (this.Lflag == false) {
            text =
              "Real-time data cannot be deleted, please select the correct record";
          }
          this.optionMin = this.$message({
            showClose: true,
            message: text,
            duration: 3 * 1000,
            center: true,
            type: "warning",
            customClass: "customclass",
          });
        } else {
          this.delete_flag = true;
        }
      } else if (flag == true) {
        delete_timelag(
          this.$qs.stringify({ site: this.$store.state.site, name: this.value })
        ).then((res) => {
          if (res.data == 1) {
            var text = "删除成功";
            if (this.Lflag == false) {
              text = "The deletion is successful";
            }
            this.optionMin = this.$message({
              showClose: true,
              message: text,
              duration: 2 * 1000,
              center: true,
              type: "success",
              customClass: "customclass",
            });
            this.value = null;
            this.$store.commit("seteco_value", this.value);
            get_time_lag(
              this.$qs.stringify({ site: this.$store.state.site })
            ).then((res) => {
              this.options = res.data;
              this.options.unshift({ name: "实时数据", start: "", end: "" });
            });
          } else {
            var text = "删除失败";
            if (this.Lflag == false) {
              text = "Deletion failed";
            }
            this.optionMin = this.$message({
              showClose: true,
              message: text,
              duration: 2 * 1000,
              center: true,
              type: "error",
              customClass: "customclass",
            });
          }
          this.delete_flag = false;
        });
      }
    },

    // ─── 工具函数：提取数组属性 ────────────────────────
    getAttrs(array, attr) {
      var arr = array.map((item) => {
        return item[attr];
      });
      return arr;
    },

    // ─── 跳转到羽流参数计算页面 ─────────────────────────
    compute() {
      this.$router.push("/Main/Cruise_monitoring_compute");
    },

    beforeDestroy() {
      this.$bus.$off("language-changed");
      clearInterval(this.refreshData);
      this.refreshData = null;
      // 释放 OpenLayers 地图资源
      [this.olMap1, this.olMap2, this.olMap3, this.olMap4].forEach(m => {
        if (m) m.setTarget(null);
      });
      this.olMap1 = this.olMap2 = this.olMap3 = this.olMap4 = null;
    },
  },
};
</script>
<style>
@import "~ol/ol.css";
</style>
<style scoped>
::v-deep .el-button {
  padding-left: 0.0538vw;
  padding-top: 0.0538vw;
}
::v-deep .el-slider.is-vertical .el-slider__runway {
  margin: 0 0.8602vw;
}
</style>
<style>
.chart-container {
  position: absolute;
  bottom: 0.1075vw;
  left: 0.1075vw;
  background: rgba(255, 255, 255, 0.7);
  padding: 0.0538vw;
  box-shadow: 0 0.0538vw 0.1075vw rgba(0, 0, 0, 0.1);
}

.chart {
  width: 100%;
  height: 100%;
}

.toggle-button {
  position: absolute;
  z-index: 1000;
  width: 1.0753vw;
  height: 1.0753vw;
  border: none;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.7);

  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.arrow {
  position: absolute;
  bottom: -0.0538vw;
  font-size: 1.0753vw;
  color: #333;
}
.toggle-button:hover {
  background-color: #f0f0f0;
}
.custom-slider .el-slider__button {
  width: 0.5376vw;
  height: 0.5376vw;
}

#mapControl {
  background-color: rgba(255, 255, 255, 0.8); /* 设置背景透明度 */
  border: 0.0538vw solid #ddd;
  border-radius: 0.2151vw;
  padding: 0.0538vw;
}

.mapControl .el-select-dropdown {
  background-color: rgba(
    255,
    255,
    255,
    0.8
  ) !important; /* 设置下拉框的背景色 */
  border: none !important; /* 移除边框 */
}

/* 给下拉框中的选中项添加背景色 */
.mapControl .el-select-dropdown__item.selected {
  background-color: rgba(
    255,
    255,
    255,
    0.8
  ) !important; /* 设置选中项的背景色 */
}

.btn {
  position: absolute;
  cursor: pointer;
  z-index: 10;
}
/* amap styles removed */
.description {
  height: 4.8387vh;
}

.edit {
  top: 53.7634vw;
  right: 5.3763vh;
}

.basic_info {
  resize: none;
  width: 80%;
  height: 2.1505vh;
}
.custom-switch {
  color: rgba(25, 44, 250, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  opacity: 1;
  text-align: left;
}
.custom-switch .el-switch__label * {
  font-size: 0.8602vw !important;
}
.v41_170 {
  width: 5.1613vw;
  color: rgba(0, 0, 0, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 1.0753vw;
  opacity: 1;
  text-align: left;
}

.v41_172 {
  width: 6.8817vw;
  height: 2.7957vh;
  background: rgba(25, 44, 250, 1);
  padding: 0.5914vw 2.1505vw;
  margin: 0.5376vw;
  opacity: 1;
  border-top-left-radius: 0.2688vw;
  border-top-right-radius: 0.2688vw;
  border-bottom-left-radius: 0.2688vw;
  border-bottom-right-radius: 0.2688vw;
  overflow: hidden;
}

.v41_169 {
  width: 5.1613vw;
  color: rgba(25, 44, 250, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  opacity: 1;
  text-align: left;
}

.v41_168 {
  width: 2.5806vw;
  color: rgba(255, 255, 255, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  opacity: 1;
  text-align: left;
}

.v41_166 {
  width: 98%;
  height: 100%;
  background: rgba(243, 249, 255, 1);
  outline-color: rgba(243, 249, 255, 1);
  opacity: 1;
  padding: 0vw;
  border: 0vw;
  border-top-left-radius: 0.5376vw;
  border-top-right-radius: 0.5376vw;
  border-bottom-left-radius: 0.5376vw;
  border-bottom-right-radius: 0.5376vw;
  overflow: hidden;
  color: rgba(0, 0, 0, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  text-align: left;
}

.box-card .text {
  font-size: 0.7527vw;
}

.item {
  margin-bottom: 0.9677vw;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 43.0108vw;
}
</style>